var items = {
  "block.minecraft.acacia_button": "Akasieknapp",
  "block.minecraft.acacia_door": "Akasiedør",
  "block.minecraft.acacia_fence": "Gjerde av akasietre",
  "block.minecraft.acacia_fence_gate": "Grind av akasietre",
  "block.minecraft.acacia_hanging_sign": "Hengande akasieskilt",
  "block.minecraft.acacia_leaves": "Akasielauv",
  "block.minecraft.acacia_log": "Akasiestomn",
  "block.minecraft.acacia_planks": "Akasieplankar",
  "block.minecraft.acacia_pressure_plate": "Akasietrykkplate",
  "block.minecraft.acacia_sapling": "Akasierenning",
  "block.minecraft.acacia_shelf": "Akasiehylle",
  "block.minecraft.acacia_sign": "Akasieskilt",
  "block.minecraft.acacia_slab": "Akasiehelle",
  "block.minecraft.acacia_stairs": "Akasietrapp",
  "block.minecraft.acacia_trapdoor": "Akasielem",
  "block.minecraft.acacia_wall_hanging_sign": "Hengande akasieskilt på vegg",
  "block.minecraft.acacia_wall_sign": "Akasieveggskilt",
  "block.minecraft.acacia_wood": "Akasietre",
  "block.minecraft.activator_rail": "Aktivatorskjene",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Villauk",
  "block.minecraft.amethyst_block": "Ametystblokk",
  "block.minecraft.amethyst_cluster": "Ametyskklyngje",
  "block.minecraft.ancient_debris": "Forne leivder",
  "block.minecraft.andesite": "Andesitt",
  "block.minecraft.andesite_slab": "Andesitthelle",
  "block.minecraft.andesite_stairs": "Andesittrapp",
  "block.minecraft.andesite_wall": "Andesittmur",
  "block.minecraft.anvil": "Smieste",
  "block.minecraft.attached_melon_stem": "Festa melonstilk",
  "block.minecraft.attached_pumpkin_stem": "Festa graskarstilk",
  "block.minecraft.azalea": "Lyngrose",
  "block.minecraft.azalea_leaves": "Lauv av lyngrosetre",
  "block.minecraft.azure_bluet": "Houstonia",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblokk",
  "block.minecraft.bamboo_button": "Bambusknapp",
  "block.minecraft.bamboo_door": "Bambusdør",
  "block.minecraft.bamboo_fence": "Bambusgjerde",
  "block.minecraft.bamboo_fence_gate": "Bambusgrind",
  "block.minecraft.bamboo_hanging_sign": "Hengande bambusskilt",
  "block.minecraft.bamboo_mosaic": "Bambusmosaikk",
  "block.minecraft.bamboo_mosaic_slab": "Helle av bambusmosaikk",
  "block.minecraft.bamboo_mosaic_stairs": "Trapp av bambusmosaikk",
  "block.minecraft.bamboo_planks": "Bambusplankar",
  "block.minecraft.bamboo_pressure_plate": "Bambustrykkplate",
  "block.minecraft.bamboo_sapling": "Bambusskot",
  "block.minecraft.bamboo_shelf": "Bambushylle",
  "block.minecraft.bamboo_sign": "Bambusskilt",
  "block.minecraft.bamboo_slab": "Helle av bambus",
  "block.minecraft.bamboo_stairs": "Trapp av bambus",
  "block.minecraft.bamboo_trapdoor": "Bambuslem",
  "block.minecraft.bamboo_wall_hanging_sign": "Hengande bambusskilt på vegg",
  "block.minecraft.bamboo_wall_sign": "Bambusveggskilt",
  "block.minecraft.banner.base.black": "Svart botn",
  "block.minecraft.banner.base.blue": "Blå botn",
  "block.minecraft.banner.base.brown": "Brun botn",
  "block.minecraft.banner.base.cyan": "Blågrøn botn",
  "block.minecraft.banner.base.gray": "Grå botn",
  "block.minecraft.banner.base.green": "Grøn botn",
  "block.minecraft.banner.base.light_blue": "Ljosblå botn",
  "block.minecraft.banner.base.light_gray": "Ljosgrå botn",
  "block.minecraft.banner.base.lime": "Limegrøn botn",
  "block.minecraft.banner.base.magenta": "Ljoslilla botn",
  "block.minecraft.banner.base.orange": "Oransje botn",
  "block.minecraft.banner.base.pink": "Rosa botn",
  "block.minecraft.banner.base.purple": "Lilla botn",
  "block.minecraft.banner.base.red": "Raud botn",
  "block.minecraft.banner.base.white": "Kvit botn",
  "block.minecraft.banner.base.yellow": "Gul botn",
  "block.minecraft.banner.border.black": "Svart bord",
  "block.minecraft.banner.border.blue": "Blått bord",
  "block.minecraft.banner.border.brown": "Brunt bord",
  "block.minecraft.banner.border.cyan": "Blågrønt bord",
  "block.minecraft.banner.border.gray": "Grått bord",
  "block.minecraft.banner.border.green": "Grønt bord",
  "block.minecraft.banner.border.light_blue": "Ljosblått bord",
  "block.minecraft.banner.border.light_gray": "Ljosgrått bord",
  "block.minecraft.banner.border.lime": "Limegrønt bord",
  "block.minecraft.banner.border.magenta": "Ljoslilla bord",
  "block.minecraft.banner.border.orange": "Oransje bord",
  "block.minecraft.banner.border.pink": "Rosa bord",
  "block.minecraft.banner.border.purple": "Lilla bord",
  "block.minecraft.banner.border.red": "Raudt bord",
  "block.minecraft.banner.border.white": "Kvitt bord",
  "block.minecraft.banner.border.yellow": "Gult bord",
  "block.minecraft.banner.bricks.black": "Svart mursteinmønster",
  "block.minecraft.banner.bricks.blue": "Blått mursteinmønster",
  "block.minecraft.banner.bricks.brown": "Brunt mursteinmønster",
  "block.minecraft.banner.bricks.cyan": "Blågrønt mursteinmønster",
  "block.minecraft.banner.bricks.gray": "Grått mursteinmønster",
  "block.minecraft.banner.bricks.green": "Grønt mursteinmønster",
  "block.minecraft.banner.bricks.light_blue": "Ljosblått mursteinmønster",
  "block.minecraft.banner.bricks.light_gray": "Ljosgrått mursteinmønster",
  "block.minecraft.banner.bricks.lime": "Limegrønt mursteinmønster",
  "block.minecraft.banner.bricks.magenta": "Ljoslilla mursteinmønster",
  "block.minecraft.banner.bricks.orange": "Oransje mursteinmønster",
  "block.minecraft.banner.bricks.pink": "Rosa mursteinmønster",
  "block.minecraft.banner.bricks.purple": "Lilla mursteinmønster",
  "block.minecraft.banner.bricks.red": "Raudt mursteinmønster",
  "block.minecraft.banner.bricks.white": "Kvitt mursteinmønster",
  "block.minecraft.banner.bricks.yellow": "Gult mursteinmønster",
  "block.minecraft.banner.circle.black": "Svart skive",
  "block.minecraft.banner.circle.blue": "Blå skive",
  "block.minecraft.banner.circle.brown": "Brun skive",
  "block.minecraft.banner.circle.cyan": "Blågrøn skive",
  "block.minecraft.banner.circle.gray": "Grå skive",
  "block.minecraft.banner.circle.green": "Grøn skive",
  "block.minecraft.banner.circle.light_blue": "Ljosblå skive",
  "block.minecraft.banner.circle.light_gray": "Ljosgrå skive",
  "block.minecraft.banner.circle.lime": "Limegrøn skive",
  "block.minecraft.banner.circle.magenta": "Ljoslilla skive",
  "block.minecraft.banner.circle.orange": "Oransje skive",
  "block.minecraft.banner.circle.pink": "Rosa skive",
  "block.minecraft.banner.circle.purple": "Lilla skive",
  "block.minecraft.banner.circle.red": "Raud skive",
  "block.minecraft.banner.circle.white": "Kvit skive",
  "block.minecraft.banner.circle.yellow": "Gul skive",
  "block.minecraft.banner.creeper.black": "Svart creeper",
  "block.minecraft.banner.creeper.blue": "Blå creeper",
  "block.minecraft.banner.creeper.brown": "Brun creeper",
  "block.minecraft.banner.creeper.cyan": "Blågrøn creeper",
  "block.minecraft.banner.creeper.gray": "Grå creeper",
  "block.minecraft.banner.creeper.green": "Grøn creeper",
  "block.minecraft.banner.creeper.light_blue": "Ljosblå creeper",
  "block.minecraft.banner.creeper.light_gray": "Ljosgrå creeper",
  "block.minecraft.banner.creeper.lime": "Limegrøn creeper",
  "block.minecraft.banner.creeper.magenta": "Ljoslilla creeper",
  "block.minecraft.banner.creeper.orange": "Oransje creeper",
  "block.minecraft.banner.creeper.pink": "Rosa creeper",
  "block.minecraft.banner.creeper.purple": "Lilla creeper",
  "block.minecraft.banner.creeper.red": "Raud creeper",
  "block.minecraft.banner.creeper.white": "Kvit creeper",
  "block.minecraft.banner.creeper.yellow": "Gul creeper",
  "block.minecraft.banner.cross.black": "Svart andreaskross",
  "block.minecraft.banner.cross.blue": "Blått kross",
  "block.minecraft.banner.cross.brown": "Brun kross",
  "block.minecraft.banner.cross.cyan": "Blågrøn kross",
  "block.minecraft.banner.cross.gray": "Grå kross",
  "block.minecraft.banner.cross.green": "Grøn kross",
  "block.minecraft.banner.cross.light_blue": "Ljosblå kross",
  "block.minecraft.banner.cross.light_gray": "Ljosgrå kross",
  "block.minecraft.banner.cross.lime": "Limegrøn kross",
  "block.minecraft.banner.cross.magenta": "Ljoslilla kross",
  "block.minecraft.banner.cross.orange": "Oransje kross",
  "block.minecraft.banner.cross.pink": "Rosa kross",
  "block.minecraft.banner.cross.purple": "Lilla kross",
  "block.minecraft.banner.cross.red": "Raud kross",
  "block.minecraft.banner.cross.white": "Kvit kross",
  "block.minecraft.banner.cross.yellow": "Gul kross",
  "block.minecraft.banner.curly_border.black": "Svart bord med snitt",
  "block.minecraft.banner.curly_border.blue": "Blått bord med snitt",
  "block.minecraft.banner.curly_border.brown": "Brunt bord med snitt",
  "block.minecraft.banner.curly_border.cyan": "Blågrønt bord med snitt",
  "block.minecraft.banner.curly_border.gray": "Grått bord med snitt",
  "block.minecraft.banner.curly_border.green": "Grønt bord med snitt",
  "block.minecraft.banner.curly_border.light_blue": "Ljosblått bord med snitt",
  "block.minecraft.banner.curly_border.light_gray": "Ljosgrått bord med snitt",
  "block.minecraft.banner.curly_border.lime": "Limegrønt bord med snitt",
  "block.minecraft.banner.curly_border.magenta": "Ljoslilla bord med snitt",
  "block.minecraft.banner.curly_border.orange": "Oransje bord med snitt",
  "block.minecraft.banner.curly_border.pink": "Rosa bord med snitt",
  "block.minecraft.banner.curly_border.purple": "Lilla bord med snitt",
  "block.minecraft.banner.curly_border.red": "Raudt bord med snitt",
  "block.minecraft.banner.curly_border.white": "Kvitt bord med snitt",
  "block.minecraft.banner.curly_border.yellow": "Gult bord med snitt",
  "block.minecraft.banner.diagonal_left.black": "Svart skrådelt venstre",
  "block.minecraft.banner.diagonal_left.blue": "Blå skrådelt venstre",
  "block.minecraft.banner.diagonal_left.brown": "Brun skrådelt venstre",
  "block.minecraft.banner.diagonal_left.cyan": "Blågrøn skrådelt venstre",
  "block.minecraft.banner.diagonal_left.gray": "Grå skrådelt venstre",
  "block.minecraft.banner.diagonal_left.green": "Grøn skrådelt venstre",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljosblå skrådelt venstre",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljosgrå skrådelt venstre",
  "block.minecraft.banner.diagonal_left.lime": "Limegrøn skrådelt venstre",
  "block.minecraft.banner.diagonal_left.magenta": "Ljoslilla skrådelt venstre",
  "block.minecraft.banner.diagonal_left.orange": "Oransje skrådelt venstre",
  "block.minecraft.banner.diagonal_left.pink": "Rosa skrådelt venstre",
  "block.minecraft.banner.diagonal_left.purple": "Lilla skrådelt venstre",
  "block.minecraft.banner.diagonal_left.red": "Raud skrådelt venstre",
  "block.minecraft.banner.diagonal_left.white": "Kvit skrådelt venstre",
  "block.minecraft.banner.diagonal_left.yellow": "Gul skrådelt venstre",
  "block.minecraft.banner.diagonal_right.black": "Svart skrådelt høgre",
  "block.minecraft.banner.diagonal_right.blue": "Blå skrådelt høgre",
  "block.minecraft.banner.diagonal_right.brown": "Brun skrådelt høgre",
  "block.minecraft.banner.diagonal_right.cyan": "Blågrøn skrådelt høgre",
  "block.minecraft.banner.diagonal_right.gray": "Grå skrådelt høgre",
  "block.minecraft.banner.diagonal_right.green": "Grøn skrådelt høgre",
  "block.minecraft.banner.diagonal_right.light_blue": "Ljosblå skrådelt høgre",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljosgrå skrådelt høgre",
  "block.minecraft.banner.diagonal_right.lime": "Limegrøn skrådelt høgre",
  "block.minecraft.banner.diagonal_right.magenta": "Ljoslilla skrådelt høgre",
  "block.minecraft.banner.diagonal_right.orange": "Oransje skrådelt høgre",
  "block.minecraft.banner.diagonal_right.pink": "Rosa skrådelt høgre",
  "block.minecraft.banner.diagonal_right.purple": "Lilla skrådelt høgre",
  "block.minecraft.banner.diagonal_right.red": "Raud skrådelt høgre",
  "block.minecraft.banner.diagonal_right.white": "Kvit skrådelt høgre",
  "block.minecraft.banner.diagonal_right.yellow": "Gul skrådelt høgre",
  "block.minecraft.banner.diagonal_up_left.black": "Svart omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.blue": "Blå omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.cyan": "Blågrøn omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.gray": "Grå omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.green": "Grøn omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ljosblå omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ljosgrå omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.lime": "Limegrøn omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.magenta": "Ljoslilla omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.orange": "Oransje omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.purple": "Lilla omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.red": "Raud omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.white": "Kvit omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gul omsnudd skrådelt venstre",
  "block.minecraft.banner.diagonal_up_right.black": "Svart omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.blue": "Blå omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.cyan": "Blågrøn omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.gray": "Grå omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.green": "Grøn omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljosblå omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljosgrå omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.lime": "Limegrøn omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.magenta": "Ljoslilla omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.orange": "Oransje omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilla omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.red": "Raud omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.white": "Kvit omsnudd skrådelt høgre",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gul omsnudd skrådelt høgre",
  "block.minecraft.banner.flow.black": "Svart flod",
  "block.minecraft.banner.flow.blue": "Blå flod",
  "block.minecraft.banner.flow.brown": "Brun flod",
  "block.minecraft.banner.flow.cyan": "Blågrøn flod",
  "block.minecraft.banner.flow.gray": "Grå flod",
  "block.minecraft.banner.flow.green": "Grøn flod",
  "block.minecraft.banner.flow.light_blue": "Ljosblå flod",
  "block.minecraft.banner.flow.light_gray": "Ljosgrå flod",
  "block.minecraft.banner.flow.lime": "Limegrøn flod",
  "block.minecraft.banner.flow.magenta": "Ljoslilla flod",
  "block.minecraft.banner.flow.orange": "Oransje flod",
  "block.minecraft.banner.flow.pink": "Rosa flod",
  "block.minecraft.banner.flow.purple": "Lilla flod",
  "block.minecraft.banner.flow.red": "Raud flod",
  "block.minecraft.banner.flow.white": "Kvit flod",
  "block.minecraft.banner.flow.yellow": "Gul flod",
  "block.minecraft.banner.flower.black": "Svart blome",
  "block.minecraft.banner.flower.blue": "Blå blome",
  "block.minecraft.banner.flower.brown": "Brun blome",
  "block.minecraft.banner.flower.cyan": "Blågrøn blome",
  "block.minecraft.banner.flower.gray": "Grå blome",
  "block.minecraft.banner.flower.green": "Grøn blome",
  "block.minecraft.banner.flower.light_blue": "Ljosblå blome",
  "block.minecraft.banner.flower.light_gray": "Ljosgrå blome",
  "block.minecraft.banner.flower.lime": "Limegrøn blome",
  "block.minecraft.banner.flower.magenta": "Ljoslilla blome",
  "block.minecraft.banner.flower.orange": "Oransje blome",
  "block.minecraft.banner.flower.pink": "Rosa blome",
  "block.minecraft.banner.flower.purple": "Lilla blome",
  "block.minecraft.banner.flower.red": "Raud blome",
  "block.minecraft.banner.flower.white": "Kvit blome",
  "block.minecraft.banner.flower.yellow": "Gul blome",
  "block.minecraft.banner.globe.black": "Svart klote",
  "block.minecraft.banner.globe.blue": "Blå klote",
  "block.minecraft.banner.globe.brown": "Brun klote",
  "block.minecraft.banner.globe.cyan": "Blågrøn klote",
  "block.minecraft.banner.globe.gray": "Grå klote",
  "block.minecraft.banner.globe.green": "Grøn klote",
  "block.minecraft.banner.globe.light_blue": "Ljosblå klote",
  "block.minecraft.banner.globe.light_gray": "Ljosgrå klote",
  "block.minecraft.banner.globe.lime": "Limegrøn",
  "block.minecraft.banner.globe.magenta": "Ljoslilla klote",
  "block.minecraft.banner.globe.orange": "Oransje klote",
  "block.minecraft.banner.globe.pink": "Rosa klote",
  "block.minecraft.banner.globe.purple": "Lilla klote",
  "block.minecraft.banner.globe.red": "Raud klote",
  "block.minecraft.banner.globe.white": "Kvit klote",
  "block.minecraft.banner.globe.yellow": "Gul klote",
  "block.minecraft.banner.gradient.black": "Svart gradient",
  "block.minecraft.banner.gradient.blue": "Blå gradient",
  "block.minecraft.banner.gradient.brown": "Brun gradient",
  "block.minecraft.banner.gradient.cyan": "Blågrøn gradient",
  "block.minecraft.banner.gradient.gray": "Grå gradient",
  "block.minecraft.banner.gradient.green": "Grøn gradient",
  "block.minecraft.banner.gradient.light_blue": "Ljosblå gradient",
  "block.minecraft.banner.gradient.light_gray": "Ljosgrå gradient",
  "block.minecraft.banner.gradient.lime": "Limegrøn gradient",
  "block.minecraft.banner.gradient.magenta": "Ljoslilla gradient",
  "block.minecraft.banner.gradient.orange": "Oransje gradient",
  "block.minecraft.banner.gradient.pink": "Rosa gradient",
  "block.minecraft.banner.gradient.purple": "Lilla gradient",
  "block.minecraft.banner.gradient.red": "Raud gradient",
  "block.minecraft.banner.gradient.white": "Kvit gradient",
  "block.minecraft.banner.gradient.yellow": "Gul gradient",
  "block.minecraft.banner.gradient_up.black": "Svart omvendt gradient",
  "block.minecraft.banner.gradient_up.blue": "Blå omvendt gradient",
  "block.minecraft.banner.gradient_up.brown": "Brun omvendt gradient",
  "block.minecraft.banner.gradient_up.cyan": "Blågrøn omvendt gradient",
  "block.minecraft.banner.gradient_up.gray": "Grå omvendt gradient",
  "block.minecraft.banner.gradient_up.green": "Grøn omvendt gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Ljosblå omvendt gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Ljosgrå omvendt gradient",
  "block.minecraft.banner.gradient_up.lime": "Limegrøn omvendt gradient",
  "block.minecraft.banner.gradient_up.magenta": "Ljoslilla omvendt gradient",
  "block.minecraft.banner.gradient_up.orange": "Oransje omvendt gradient",
  "block.minecraft.banner.gradient_up.pink": "Rosa omvendt gradient",
  "block.minecraft.banner.gradient_up.purple": "Lilla omvendt gradient",
  "block.minecraft.banner.gradient_up.red": "Raud omvendt gradient",
  "block.minecraft.banner.gradient_up.white": "Kvit omvendt gradient",
  "block.minecraft.banner.gradient_up.yellow": "Gul omvendt gradient",
  "block.minecraft.banner.guster.black": "Svart vindkaster",
  "block.minecraft.banner.guster.blue": "Blå vindkaster",
  "block.minecraft.banner.guster.brown": "Brun vindkaster",
  "block.minecraft.banner.guster.cyan": "Turkis vindkaster",
  "block.minecraft.banner.guster.gray": "Grå vindkaster",
  "block.minecraft.banner.guster.green": "Grønn vindkaster",
  "block.minecraft.banner.guster.light_blue": "Lyseblå vindkaster",
  "block.minecraft.banner.guster.light_gray": "Lysegrå vindkaster",
  "block.minecraft.banner.guster.lime": "Limegrønn vindkaster",
  "block.minecraft.banner.guster.magenta": "Magenta vindkaster",
  "block.minecraft.banner.guster.orange": "Oransje vindkaster",
  "block.minecraft.banner.guster.pink": "Rosa vindkaster",
  "block.minecraft.banner.guster.purple": "Lilla vindkaster",
  "block.minecraft.banner.guster.red": "Rød vindkaster",
  "block.minecraft.banner.guster.white": "Hvit vindkaster",
  "block.minecraft.banner.guster.yellow": "Gul vindkaster",
  "block.minecraft.banner.half_horizontal.black": "Svart overdel",
  "block.minecraft.banner.half_horizontal.blue": "Blå overdel",
  "block.minecraft.banner.half_horizontal.brown": "Brun overdel",
  "block.minecraft.banner.half_horizontal.cyan": "Blågrøn overdel",
  "block.minecraft.banner.half_horizontal.gray": "Grå overdel",
  "block.minecraft.banner.half_horizontal.green": "Grøn overdel",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljosblå overdel",
  "block.minecraft.banner.half_horizontal.light_gray": "Ljosgrå overdel",
  "block.minecraft.banner.half_horizontal.lime": "Limegrøn overdel",
  "block.minecraft.banner.half_horizontal.magenta": "Ljoslilla overdel",
  "block.minecraft.banner.half_horizontal.orange": "Oransje overdel",
  "block.minecraft.banner.half_horizontal.pink": "Rosa overdel",
  "block.minecraft.banner.half_horizontal.purple": "Lilla overdel",
  "block.minecraft.banner.half_horizontal.red": "Raud overdel",
  "block.minecraft.banner.half_horizontal.white": "Kvit overdel",
  "block.minecraft.banner.half_horizontal.yellow": "Gul overdel",
  "block.minecraft.banner.half_horizontal_bottom.black": "Svart underdel",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blå underdel",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun underdel",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Blågrøn underdel",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grå underdel",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grøn underdel",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljosblå underdel",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljosgrå underdel",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limegrøn underdel",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Ljoslilla underdel",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oransje underdel",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rosa underdel",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lilla underdel",
  "block.minecraft.banner.half_horizontal_bottom.red": "Raud underdel",
  "block.minecraft.banner.half_horizontal_bottom.white": "Kvit underdel",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gul underdel",
  "block.minecraft.banner.half_vertical.black": "Svart venstredel",
  "block.minecraft.banner.half_vertical.blue": "Blå venstredel",
  "block.minecraft.banner.half_vertical.brown": "Brun venstredel",
  "block.minecraft.banner.half_vertical.cyan": "Blågrøn venstredel",
  "block.minecraft.banner.half_vertical.gray": "Grå venstredel",
  "block.minecraft.banner.half_vertical.green": "Grøn venstredel",
  "block.minecraft.banner.half_vertical.light_blue": "Ljosblå venstredel",
  "block.minecraft.banner.half_vertical.light_gray": "Ljosgrå venstredel",
  "block.minecraft.banner.half_vertical.lime": "Limegrøn venstredel",
  "block.minecraft.banner.half_vertical.magenta": "Ljoslilla venstredel",
  "block.minecraft.banner.half_vertical.orange": "Oransje venstredel",
  "block.minecraft.banner.half_vertical.pink": "Rosa venstredel",
  "block.minecraft.banner.half_vertical.purple": "Lilla venstredel",
  "block.minecraft.banner.half_vertical.red": "Raud venstredel",
  "block.minecraft.banner.half_vertical.white": "Kvit venstredel",
  "block.minecraft.banner.half_vertical.yellow": "Gul venstredel",
  "block.minecraft.banner.half_vertical_right.black": "Svart høgredel",
  "block.minecraft.banner.half_vertical_right.blue": "Blå høgredel",
  "block.minecraft.banner.half_vertical_right.brown": "Brun høgredel",
  "block.minecraft.banner.half_vertical_right.cyan": "Blågrøn høgredel",
  "block.minecraft.banner.half_vertical_right.gray": "Grå høgredel",
  "block.minecraft.banner.half_vertical_right.green": "Grøn høgredel",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljosblå høgredel",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljosgrå høgredel",
  "block.minecraft.banner.half_vertical_right.lime": "Limegrøn høgredel",
  "block.minecraft.banner.half_vertical_right.magenta": "Ljoslilla høgredel",
  "block.minecraft.banner.half_vertical_right.orange": "Oransje høgredel",
  "block.minecraft.banner.half_vertical_right.pink": "Rosa høgredel",
  "block.minecraft.banner.half_vertical_right.purple": "Lilla høgredel",
  "block.minecraft.banner.half_vertical_right.red": "Raud høgredel",
  "block.minecraft.banner.half_vertical_right.white": "Kvit høgredel",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul høgredel",
  "block.minecraft.banner.mojang.black": "Svart ting",
  "block.minecraft.banner.mojang.blue": "Blå ting",
  "block.minecraft.banner.mojang.brown": "Brun ting",
  "block.minecraft.banner.mojang.cyan": "Blågrøn ting",
  "block.minecraft.banner.mojang.gray": "Grå ting",
  "block.minecraft.banner.mojang.green": "Grøn ting",
  "block.minecraft.banner.mojang.light_blue": "Ljosblå ting",
  "block.minecraft.banner.mojang.light_gray": "Ljosgrå ting",
  "block.minecraft.banner.mojang.lime": "Limegrøn ting",
  "block.minecraft.banner.mojang.magenta": "Ljoslilla ting",
  "block.minecraft.banner.mojang.orange": "Oransje ting",
  "block.minecraft.banner.mojang.pink": "Rosa ting",
  "block.minecraft.banner.mojang.purple": "Lilla ting",
  "block.minecraft.banner.mojang.red": "Raud ting",
  "block.minecraft.banner.mojang.white": "Kvit ting",
  "block.minecraft.banner.mojang.yellow": "Gul ting",
  "block.minecraft.banner.piglin.black": "Svart snut",
  "block.minecraft.banner.piglin.blue": "Blå snut",
  "block.minecraft.banner.piglin.brown": "Brun snut",
  "block.minecraft.banner.piglin.cyan": "Blågrøn snut",
  "block.minecraft.banner.piglin.gray": "Grå snut",
  "block.minecraft.banner.piglin.green": "Grøn snut",
  "block.minecraft.banner.piglin.light_blue": "Ljosblå snut",
  "block.minecraft.banner.piglin.light_gray": "Ljosgrå snut",
  "block.minecraft.banner.piglin.lime": "Limegrøn snut",
  "block.minecraft.banner.piglin.magenta": "Ljoslilla snut",
  "block.minecraft.banner.piglin.orange": "Oransje snut",
  "block.minecraft.banner.piglin.pink": "Rosa snut",
  "block.minecraft.banner.piglin.purple": "Lilla snut",
  "block.minecraft.banner.piglin.red": "Raud snut",
  "block.minecraft.banner.piglin.white": "Kvit snut",
  "block.minecraft.banner.piglin.yellow": "Gul snut",
  "block.minecraft.banner.rhombus.black": "Svart rute",
  "block.minecraft.banner.rhombus.blue": "Blå rute",
  "block.minecraft.banner.rhombus.brown": "Brun rute",
  "block.minecraft.banner.rhombus.cyan": "Blågrøn rute",
  "block.minecraft.banner.rhombus.gray": "Grå rute",
  "block.minecraft.banner.rhombus.green": "Grøn rute",
  "block.minecraft.banner.rhombus.light_blue": "Ljosblå rute",
  "block.minecraft.banner.rhombus.light_gray": "Ljosgrå rute",
  "block.minecraft.banner.rhombus.lime": "Limegrøn rute",
  "block.minecraft.banner.rhombus.magenta": "Ljoslilla rute",
  "block.minecraft.banner.rhombus.orange": "Oransje rute",
  "block.minecraft.banner.rhombus.pink": "Rosa rute",
  "block.minecraft.banner.rhombus.purple": "Lilla rute",
  "block.minecraft.banner.rhombus.red": "Raud rute",
  "block.minecraft.banner.rhombus.white": "Kvit rute",
  "block.minecraft.banner.rhombus.yellow": "Gul rute",
  "block.minecraft.banner.skull.black": "Svart daudinghovud",
  "block.minecraft.banner.skull.blue": "Blått daudinghovud",
  "block.minecraft.banner.skull.brown": "Brunt daudinghovud",
  "block.minecraft.banner.skull.cyan": "Blågrønt daudinghovud",
  "block.minecraft.banner.skull.gray": "Grått daudinghovud",
  "block.minecraft.banner.skull.green": "Grønt daudinghovud",
  "block.minecraft.banner.skull.light_blue": "Ljosblått daudinghovud",
  "block.minecraft.banner.skull.light_gray": "Ljosgrått daudinghovud",
  "block.minecraft.banner.skull.lime": "Limegrønt daudinghovud",
  "block.minecraft.banner.skull.magenta": "Ljoslilla daudinghovud",
  "block.minecraft.banner.skull.orange": "Oransje daudinghovud",
  "block.minecraft.banner.skull.pink": "Rosa daudinghovud",
  "block.minecraft.banner.skull.purple": "Lilla daudinghovud",
  "block.minecraft.banner.skull.red": "Raudt daudinghovud",
  "block.minecraft.banner.skull.white": "Kvitt daudinghovud",
  "block.minecraft.banner.skull.yellow": "Gul daudinghovud",
  "block.minecraft.banner.small_stripes.black": "Svarte stolpar",
  "block.minecraft.banner.small_stripes.blue": "Blåe striper",
  "block.minecraft.banner.small_stripes.brown": "Brune striper",
  "block.minecraft.banner.small_stripes.cyan": "Blågrøne striper",
  "block.minecraft.banner.small_stripes.gray": "Gråe stolpar",
  "block.minecraft.banner.small_stripes.green": "Grøne striper",
  "block.minecraft.banner.small_stripes.light_blue": "Ljosblåe stolpar",
  "block.minecraft.banner.small_stripes.light_gray": "Ljosgråe stolpar",
  "block.minecraft.banner.small_stripes.lime": "Limegrøne stolpar",
  "block.minecraft.banner.small_stripes.magenta": "Ljoslilla stolpar",
  "block.minecraft.banner.small_stripes.orange": "Oransje stolpar",
  "block.minecraft.banner.small_stripes.pink": "Rosa stolpar",
  "block.minecraft.banner.small_stripes.purple": "Lilla striper",
  "block.minecraft.banner.small_stripes.red": "Raude striper",
  "block.minecraft.banner.small_stripes.white": "Kvite stolpar",
  "block.minecraft.banner.small_stripes.yellow": "Gule stolpar",
  "block.minecraft.banner.square_bottom_left.black": "Svart nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.blue": "Blå nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.brown": "Brun nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.cyan": "Blågrøn nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.gray": "Grå nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.green": "Grøn nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljosblå nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljosgrå nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.lime": "Limegrøn nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.magenta": "Ljoslilla nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.orange": "Oransje nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.pink": "Rosa nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.purple": "Lilla nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.red": "Raud nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.white": "Kvit nedre venstrekanton",
  "block.minecraft.banner.square_bottom_left.yellow": "Gul nedre venstrekanton",
  "block.minecraft.banner.square_bottom_right.black": "Svart nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.blue": "Blå nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.brown": "Brun nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.cyan": "Blågrøn nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.gray": "Grå nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.green": "Grøn nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljosblå nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljosgrå nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.lime": "Limegrøn nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.magenta": "Ljoslilla nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.orange": "Oransje nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.pink": "Rosa nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.purple": "Lilla nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.red": "Raud nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.white": "Kvit nedre høgrekanton",
  "block.minecraft.banner.square_bottom_right.yellow": "Gul nedre høgrekanton",
  "block.minecraft.banner.square_top_left.black": "Svart øvre venstrekanton",
  "block.minecraft.banner.square_top_left.blue": "Blå øvre venstrekanton",
  "block.minecraft.banner.square_top_left.brown": "Brun øvre venstrekanton",
  "block.minecraft.banner.square_top_left.cyan": "Blågrøn øvre venstrekanton",
  "block.minecraft.banner.square_top_left.gray": "Grå øvre venstrekanton",
  "block.minecraft.banner.square_top_left.green": "Grøn øvre venstrekanton",
  "block.minecraft.banner.square_top_left.light_blue": "Ljosblå øvre venstrekanton",
  "block.minecraft.banner.square_top_left.light_gray": "Ljosgrå øvre venstrekanton",
  "block.minecraft.banner.square_top_left.lime": "Limegrøn øvre venstrekanton",
  "block.minecraft.banner.square_top_left.magenta": "Ljoslilla øvre venstrekanton",
  "block.minecraft.banner.square_top_left.orange": "Oransje øvre venstrekanton",
  "block.minecraft.banner.square_top_left.pink": "Rosa øvre venstrekanton",
  "block.minecraft.banner.square_top_left.purple": "Lilla øvre venstrekanton",
  "block.minecraft.banner.square_top_left.red": "Raud øvre venstrekanton",
  "block.minecraft.banner.square_top_left.white": "Kvit øvre venstrekanton",
  "block.minecraft.banner.square_top_left.yellow": "Gul øvre venstrekanton",
  "block.minecraft.banner.square_top_right.black": "Svart øvre høgrekanton",
  "block.minecraft.banner.square_top_right.blue": "Blå øvre høgrekanton",
  "block.minecraft.banner.square_top_right.brown": "Brun øvre høgrekanton",
  "block.minecraft.banner.square_top_right.cyan": "Blågrøn øvre høgrekanton",
  "block.minecraft.banner.square_top_right.gray": "Grå øvre høgrekanton",
  "block.minecraft.banner.square_top_right.green": "Grøn øvre høgrekanton",
  "block.minecraft.banner.square_top_right.light_blue": "Ljosblå øvre høgrekanton",
  "block.minecraft.banner.square_top_right.light_gray": "Ljosgrå øvre høgrekanton",
  "block.minecraft.banner.square_top_right.lime": "Limegrøn øvre høgrekanton",
  "block.minecraft.banner.square_top_right.magenta": "Ljoslilla øvre høgrekanton",
  "block.minecraft.banner.square_top_right.orange": "Oransje øvre høgrekanton",
  "block.minecraft.banner.square_top_right.pink": "Rosa øvre høgrekanton",
  "block.minecraft.banner.square_top_right.purple": "Lilla øvre høgrekanton",
  "block.minecraft.banner.square_top_right.red": "Raud øvre høgrekanton",
  "block.minecraft.banner.square_top_right.white": "Kvit øvre høgrekanton",
  "block.minecraft.banner.square_top_right.yellow": "Gul øvre høgrekanton",
  "block.minecraft.banner.straight_cross.black": "Svart kross",
  "block.minecraft.banner.straight_cross.blue": "Blå kross",
  "block.minecraft.banner.straight_cross.brown": "Brun kross",
  "block.minecraft.banner.straight_cross.cyan": "Blågrøn kross",
  "block.minecraft.banner.straight_cross.gray": "Grå kross",
  "block.minecraft.banner.straight_cross.green": "Grøn kross",
  "block.minecraft.banner.straight_cross.light_blue": "Ljosblå kross",
  "block.minecraft.banner.straight_cross.light_gray": "Ljosgrå kross",
  "block.minecraft.banner.straight_cross.lime": "Limegrøn kross",
  "block.minecraft.banner.straight_cross.magenta": "Ljoslilla kross",
  "block.minecraft.banner.straight_cross.orange": "Oransje kross",
  "block.minecraft.banner.straight_cross.pink": "Rosa kross",
  "block.minecraft.banner.straight_cross.purple": "Lilla kross",
  "block.minecraft.banner.straight_cross.red": "Raud kross",
  "block.minecraft.banner.straight_cross.white": "Kvit kross",
  "block.minecraft.banner.straight_cross.yellow": "Gul kross",
  "block.minecraft.banner.stripe_bottom.black": "Svart skjoldfot",
  "block.minecraft.banner.stripe_bottom.blue": "Blått botnband",
  "block.minecraft.banner.stripe_bottom.brown": "Brunt botnband",
  "block.minecraft.banner.stripe_bottom.cyan": "Blågrønt botnband",
  "block.minecraft.banner.stripe_bottom.gray": "Grått botnband",
  "block.minecraft.banner.stripe_bottom.green": "Grønt botnband",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljosblått botnband",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljosgrått botnband",
  "block.minecraft.banner.stripe_bottom.lime": "Limegrønt botnband",
  "block.minecraft.banner.stripe_bottom.magenta": "Ljoslilla botnband",
  "block.minecraft.banner.stripe_bottom.orange": "Oransje botnband",
  "block.minecraft.banner.stripe_bottom.pink": "Rosa botnband",
  "block.minecraft.banner.stripe_bottom.purple": "Lilla botnband",
  "block.minecraft.banner.stripe_bottom.red": "Raudt botnband",
  "block.minecraft.banner.stripe_bottom.white": "Kvitt botnband",
  "block.minecraft.banner.stripe_bottom.yellow": "Gult botnband",
  "block.minecraft.banner.stripe_center.black": "Svart stolpe",
  "block.minecraft.banner.stripe_center.blue": "Blå stolpe",
  "block.minecraft.banner.stripe_center.brown": "Brun stolpe",
  "block.minecraft.banner.stripe_center.cyan": "Blågrøn stolpe",
  "block.minecraft.banner.stripe_center.gray": "Grå stolpe",
  "block.minecraft.banner.stripe_center.green": "Grøn stolpe",
  "block.minecraft.banner.stripe_center.light_blue": "Ljosblå stolpe",
  "block.minecraft.banner.stripe_center.light_gray": "Ljosgrå stolpe",
  "block.minecraft.banner.stripe_center.lime": "Limegrøn stolpe",
  "block.minecraft.banner.stripe_center.magenta": "Ljoslilla stolpe",
  "block.minecraft.banner.stripe_center.orange": "Oransje stolpe",
  "block.minecraft.banner.stripe_center.pink": "Rosa stolpe",
  "block.minecraft.banner.stripe_center.purple": "Lilla stolpe",
  "block.minecraft.banner.stripe_center.red": "Raud stolpe",
  "block.minecraft.banner.stripe_center.white": "Kvit stolpe",
  "block.minecraft.banner.stripe_center.yellow": "Gul stolpe",
  "block.minecraft.banner.stripe_downleft.black": "Svart band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.blue": "Blått band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.brown": "Brunt band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.cyan": "Blågrøn band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.gray": "Grått band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.green": "Grøn band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljosblått band frå høgretopp til vestrebotn",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljosgrått band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.lime": "Limegrønt band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.magenta": "Ljoslilla band frå høgretopp til vestrebotn",
  "block.minecraft.banner.stripe_downleft.orange": "Oransje band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.purple": "Lilla band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.red": "Raudt band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.white": "Kvitt band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downleft.yellow": "Gult band frå høgretopp til venstrebotn",
  "block.minecraft.banner.stripe_downright.black": "Svart skråbjelke",
  "block.minecraft.banner.stripe_downright.blue": "Blått band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.brown": "Brunt band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.cyan": "Blågrønt band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.gray": "Grått band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.green": "Grønt band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljosblått band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljosgrått band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.lime": "Limegrønt band frå venstretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.magenta": "Ljoslilla band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.orange": "Oransje band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.pink": "Rosa band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.purple": "Lilla band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.red": "Raudt band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.white": "Kvitt band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_downright.yellow": "Gult band frå ventretopp til høgrebotn",
  "block.minecraft.banner.stripe_left.black": "Svart høgrestolpe",
  "block.minecraft.banner.stripe_left.blue": "Blå høgrestolpe",
  "block.minecraft.banner.stripe_left.brown": "Brun høgrestolpe",
  "block.minecraft.banner.stripe_left.cyan": "Blågrøn høgrestolpe",
  "block.minecraft.banner.stripe_left.gray": "Grå høgrestolpe",
  "block.minecraft.banner.stripe_left.green": "Grøn høgrestolpe",
  "block.minecraft.banner.stripe_left.light_blue": "Ljosblå høgrestolpe",
  "block.minecraft.banner.stripe_left.light_gray": "Ljosgrå høgrestolpe",
  "block.minecraft.banner.stripe_left.lime": "Limegrøn høgrestolpe",
  "block.minecraft.banner.stripe_left.magenta": "Ljoslilla høgrestolpe",
  "block.minecraft.banner.stripe_left.orange": "Oransje høgrestolpe",
  "block.minecraft.banner.stripe_left.pink": "Rosa høgrestolpe",
  "block.minecraft.banner.stripe_left.purple": "Lilla høgrestolpe",
  "block.minecraft.banner.stripe_left.red": "Raud høgrestolpe",
  "block.minecraft.banner.stripe_left.white": "Kvit høgrestolpe",
  "block.minecraft.banner.stripe_left.yellow": "Gul høgrestolpe",
  "block.minecraft.banner.stripe_middle.black": "Svart bjelke",
  "block.minecraft.banner.stripe_middle.blue": "Blått vassrett midband",
  "block.minecraft.banner.stripe_middle.brown": "Brunt vassrett midband",
  "block.minecraft.banner.stripe_middle.cyan": "Blågrønt vassrett midband",
  "block.minecraft.banner.stripe_middle.gray": "Grått vassrett midband",
  "block.minecraft.banner.stripe_middle.green": "Grønt vassrett midband",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljosblått vassrett midband",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljosgrått vassrett midband",
  "block.minecraft.banner.stripe_middle.lime": "Limegrønt vassrett midband",
  "block.minecraft.banner.stripe_middle.magenta": "Ljoslilla vassrett midband",
  "block.minecraft.banner.stripe_middle.orange": "Oransje vassrett midband",
  "block.minecraft.banner.stripe_middle.pink": "Rosa vassrett midband",
  "block.minecraft.banner.stripe_middle.purple": "Lilla vassrett midband",
  "block.minecraft.banner.stripe_middle.red": "Raudt vassrett midband",
  "block.minecraft.banner.stripe_middle.white": "Kvitt vassrett midband",
  "block.minecraft.banner.stripe_middle.yellow": "Gult vassrett midband",
  "block.minecraft.banner.stripe_right.black": "Svart venstrestolpe",
  "block.minecraft.banner.stripe_right.blue": "Blå venstrestolpe",
  "block.minecraft.banner.stripe_right.brown": "Brun venstrestolpe",
  "block.minecraft.banner.stripe_right.cyan": "Blågrøn venstrestolpe",
  "block.minecraft.banner.stripe_right.gray": "Grå venstrestolpe",
  "block.minecraft.banner.stripe_right.green": "Grøn venstrestolpe",
  "block.minecraft.banner.stripe_right.light_blue": "Ljosblå venstrestolpe",
  "block.minecraft.banner.stripe_right.light_gray": "Ljosgrå venstrestolpe",
  "block.minecraft.banner.stripe_right.lime": "Limegrøn venstrestolpe",
  "block.minecraft.banner.stripe_right.magenta": "Ljoslilla venstrestolpe",
  "block.minecraft.banner.stripe_right.orange": "Oransje venstrestolpe",
  "block.minecraft.banner.stripe_right.pink": "Rosa venstrestolpe",
  "block.minecraft.banner.stripe_right.purple": "Lilla venstrestolpe",
  "block.minecraft.banner.stripe_right.red": "Raud venstrestolpe",
  "block.minecraft.banner.stripe_right.white": "Kvit venstrestolpe",
  "block.minecraft.banner.stripe_right.yellow": "Gul venstrestolpe",
  "block.minecraft.banner.stripe_top.black": "Svart skjoldhovud",
  "block.minecraft.banner.stripe_top.blue": "Blått toppband",
  "block.minecraft.banner.stripe_top.brown": "Brunt toppband",
  "block.minecraft.banner.stripe_top.cyan": "Blågrønt toppband",
  "block.minecraft.banner.stripe_top.gray": "Grått toppband",
  "block.minecraft.banner.stripe_top.green": "Grønt toppband",
  "block.minecraft.banner.stripe_top.light_blue": "Ljosblått toppband",
  "block.minecraft.banner.stripe_top.light_gray": "Ljosgrått toppband",
  "block.minecraft.banner.stripe_top.lime": "Limegrønt toppband",
  "block.minecraft.banner.stripe_top.magenta": "Ljoslilla toppband",
  "block.minecraft.banner.stripe_top.orange": "Oransje toppband",
  "block.minecraft.banner.stripe_top.pink": "Rosa toppband",
  "block.minecraft.banner.stripe_top.purple": "Lilla toppband",
  "block.minecraft.banner.stripe_top.red": "Raudt toppband",
  "block.minecraft.banner.stripe_top.white": "Kvitt toppband",
  "block.minecraft.banner.stripe_top.yellow": "Gult toppband",
  "block.minecraft.banner.triangle_bottom.black": "Svart sparre",
  "block.minecraft.banner.triangle_bottom.blue": "Blå sparre",
  "block.minecraft.banner.triangle_bottom.brown": "Brun sparre",
  "block.minecraft.banner.triangle_bottom.cyan": "Blågrøn sparre",
  "block.minecraft.banner.triangle_bottom.gray": "Grå sparre",
  "block.minecraft.banner.triangle_bottom.green": "Grøn sparre",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljosblå sparre",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljosgrå sparre",
  "block.minecraft.banner.triangle_bottom.lime": "Limegrøn sparre",
  "block.minecraft.banner.triangle_bottom.magenta": "Ljoslilla sparre",
  "block.minecraft.banner.triangle_bottom.orange": "Oransje sparre",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa sparre",
  "block.minecraft.banner.triangle_bottom.purple": "Lilla sparre",
  "block.minecraft.banner.triangle_bottom.red": "Raud sparre",
  "block.minecraft.banner.triangle_bottom.white": "Kvit sparre",
  "block.minecraft.banner.triangle_bottom.yellow": "Gul sparre",
  "block.minecraft.banner.triangle_top.black": "Svart omvendt sparre",
  "block.minecraft.banner.triangle_top.blue": "Blå omvendt sparre",
  "block.minecraft.banner.triangle_top.brown": "Brun omvendt sparre",
  "block.minecraft.banner.triangle_top.cyan": "Blågrøn omvendt sparre",
  "block.minecraft.banner.triangle_top.gray": "Grå omvendt sparre",
  "block.minecraft.banner.triangle_top.green": "Grøn omvendt sparre",
  "block.minecraft.banner.triangle_top.light_blue": "Ljosblå omvendt sparre",
  "block.minecraft.banner.triangle_top.light_gray": "Ljosgrå omvendt sparre",
  "block.minecraft.banner.triangle_top.lime": "Limegrøn omvendt sparre",
  "block.minecraft.banner.triangle_top.magenta": "Ljoslilla omvendt sparre",
  "block.minecraft.banner.triangle_top.orange": "Oransje omvendt sparre",
  "block.minecraft.banner.triangle_top.pink": "Rosa omvendt sparre",
  "block.minecraft.banner.triangle_top.purple": "Lilla omvendt sparre",
  "block.minecraft.banner.triangle_top.red": "Raud omvendt sparre",
  "block.minecraft.banner.triangle_top.white": "Kvit omvendt sparre",
  "block.minecraft.banner.triangle_top.yellow": "Gul omvendt sparre",
  "block.minecraft.banner.triangles_bottom.black": "Svart tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.blue": "Blått tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.brown": "Brunt tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.cyan": "Blågrønt tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.gray": "Grått tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.green": "Grønt tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljosblått tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljosgrått tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.lime": "Limegrønt tannsnitt botn",
  "block.minecraft.banner.triangles_bottom.magenta": "Ljoslilla tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.orange": "Oransje tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.purple": "Lilla tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.red": "Raudt tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.white": "Kvitt tannsnitt nede",
  "block.minecraft.banner.triangles_bottom.yellow": "Gult tannsnitt nede",
  "block.minecraft.banner.triangles_top.black": "Svart tannsnitt oppe",
  "block.minecraft.banner.triangles_top.blue": "Blått tannsnitt oppe",
  "block.minecraft.banner.triangles_top.brown": "Brunt tannsnitt oppe",
  "block.minecraft.banner.triangles_top.cyan": "Blågrønt tannsnitt oppe",
  "block.minecraft.banner.triangles_top.gray": "Grått tannsnitt oppe",
  "block.minecraft.banner.triangles_top.green": "Grønt tannsnitt oppe",
  "block.minecraft.banner.triangles_top.light_blue": "Ljosblått tannsnitt oppe",
  "block.minecraft.banner.triangles_top.light_gray": "Ljosgrått tannsnitt oppe",
  "block.minecraft.banner.triangles_top.lime": "Limegrønt tannsnitt topp",
  "block.minecraft.banner.triangles_top.magenta": "Ljoslilla tannsnitt oppe",
  "block.minecraft.banner.triangles_top.orange": "Oransje tannsnitt oppe",
  "block.minecraft.banner.triangles_top.pink": "Rosa tannsnitt oppe",
  "block.minecraft.banner.triangles_top.purple": "Lilla tannsnitt oppe",
  "block.minecraft.banner.triangles_top.red": "Raudt tannsnitt oppe",
  "block.minecraft.banner.triangles_top.white": "Kvitt tannsnitt oppe",
  "block.minecraft.banner.triangles_top.yellow": "Gult tannsnitt oppe",
  "block.minecraft.barrel": "Tunne",
  "block.minecraft.barrier": "Spelskjold",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Varde",
  "block.minecraft.beacon.primary": "Primærkraft",
  "block.minecraft.beacon.secondary": "Sekundærkraft",
  "block.minecraft.bed.no_sleep": "Du kan berre sova på natta eller ved torevêr",
  "block.minecraft.bed.not_safe": "Du kan ikkje sova no. Monster er i nærleiken",
  "block.minecraft.bed.obstructed": "Senga er sperra",
  "block.minecraft.bed.occupied": "Senga er oppteka",
  "block.minecraft.bed.too_far_away": "Senga er for langt undan",
  "block.minecraft.bedrock": "Berggrunn",
  "block.minecraft.bee_nest": "Biebol",
  "block.minecraft.beehive": "Biekube",
  "block.minecraft.beetroots": "Raudbetar",
  "block.minecraft.bell": "Bjølle",
  "block.minecraft.big_dripleaf": "Stort droplauv",
  "block.minecraft.big_dripleaf_stem": "Stilk av stort droplauv",
  "block.minecraft.birch_button": "Bjørkeknapp",
  "block.minecraft.birch_door": "Bjørkedør",
  "block.minecraft.birch_fence": "Gjerde av bjørk",
  "block.minecraft.birch_fence_gate": "Grind av bjørk",
  "block.minecraft.birch_hanging_sign": "Hengande bjørkeskilt",
  "block.minecraft.birch_leaves": "Bjørkelauv",
  "block.minecraft.birch_log": "Bjørkestomn",
  "block.minecraft.birch_planks": "Bjørkeplankar",
  "block.minecraft.birch_pressure_plate": "Bjørketrykkplate",
  "block.minecraft.birch_sapling": "Bjørkerenning",
  "block.minecraft.birch_shelf": "Bjørkehylle",
  "block.minecraft.birch_sign": "Bjørkeskilt",
  "block.minecraft.birch_slab": "Bjørkehelle",
  "block.minecraft.birch_stairs": "Bjørketrapp",
  "block.minecraft.birch_trapdoor": "Bjørkelem",
  "block.minecraft.birch_wall_hanging_sign": "Hengande bjørkeskilt på vegg",
  "block.minecraft.birch_wall_sign": "Bjørkeveggskilt",
  "block.minecraft.birch_wood": "Bjørketre",
  "block.minecraft.black_banner": "Svart fane",
  "block.minecraft.black_bed": "Svart seng",
  "block.minecraft.black_candle": "Svart voksljos",
  "block.minecraft.black_candle_cake": "Kake med svart voksljos",
  "block.minecraft.black_carpet": "Svart golvteppe",
  "block.minecraft.black_concrete": "Svart betong",
  "block.minecraft.black_concrete_powder": "Svart betongpulver",
  "block.minecraft.black_glazed_terracotta": "Svart glasert terrakotta",
  "block.minecraft.black_shulker_box": "Svart shulkerboks",
  "block.minecraft.black_stained_glass": "Svart glas",
  "block.minecraft.black_stained_glass_pane": "Svart glasrute",
  "block.minecraft.black_terracotta": "Svart terrakotta",
  "block.minecraft.black_wool": "Svart ull",
  "block.minecraft.blackstone": "Svartstein",
  "block.minecraft.blackstone_slab": "Svartsteinshelle",
  "block.minecraft.blackstone_stairs": "Svartsteinstrapp",
  "block.minecraft.blackstone_wall": "Svartsteinsmur",
  "block.minecraft.blast_furnace": "Malmomn",
  "block.minecraft.blue_banner": "Blå fane",
  "block.minecraft.blue_bed": "Blå seng",
  "block.minecraft.blue_candle": "Blått voksljos",
  "block.minecraft.blue_candle_cake": "Kake med blått voksljos",
  "block.minecraft.blue_carpet": "Blått golvteppe",
  "block.minecraft.blue_concrete": "Blå betong",
  "block.minecraft.blue_concrete_powder": "Blått betongpulver",
  "block.minecraft.blue_glazed_terracotta": "Blå glasert terrakotta",
  "block.minecraft.blue_ice": "Blåis",
  "block.minecraft.blue_orchid": "Blå orkidé",
  "block.minecraft.blue_shulker_box": "Blå shulkerboks",
  "block.minecraft.blue_stained_glass": "Blått glas",
  "block.minecraft.blue_stained_glass_pane": "Blå glasrute",
  "block.minecraft.blue_terracotta": "Blå terrakotta",
  "block.minecraft.blue_wool": "Blå ull",
  "block.minecraft.bone_block": "Beinblokk",
  "block.minecraft.bookshelf": "Bokhylle",
  "block.minecraft.brain_coral": "Hjernekorall",
  "block.minecraft.brain_coral_block": "Hjernekorallblokk",
  "block.minecraft.brain_coral_fan": "Hjernekorallvifte",
  "block.minecraft.brain_coral_wall_fan": "Hjernekorallveggvifte",
  "block.minecraft.brewing_stand": "Bryggjereiskap",
  "block.minecraft.brick_slab": "Murhelle",
  "block.minecraft.brick_stairs": "Murtrapp",
  "block.minecraft.brick_wall": "Teglmur",
  "block.minecraft.bricks": "Murstein",
  "block.minecraft.brown_banner": "Brun fane",
  "block.minecraft.brown_bed": "Brun seng",
  "block.minecraft.brown_candle": "Brunt voksljos",
  "block.minecraft.brown_candle_cake": "Kake med brunt voksljos",
  "block.minecraft.brown_carpet": "Brunt golvteppe",
  "block.minecraft.brown_concrete": "Brun betong",
  "block.minecraft.brown_concrete_powder": "Brunt betongpulver",
  "block.minecraft.brown_glazed_terracotta": "Brun glasert terrakotta",
  "block.minecraft.brown_mushroom": "Brun sopp",
  "block.minecraft.brown_mushroom_block": "Brun soppblokk",
  "block.minecraft.brown_shulker_box": "Brun shulkerboks",
  "block.minecraft.brown_stained_glass": "Brunt glas",
  "block.minecraft.brown_stained_glass_pane": "Brun glasrute",
  "block.minecraft.brown_terracotta": "Brun terrakotta",
  "block.minecraft.brown_wool": "Brun ull",
  "block.minecraft.bubble_column": "Boblesøyle",
  "block.minecraft.bubble_coral": "Boblekorall",
  "block.minecraft.bubble_coral_block": "Boblekorallblokk",
  "block.minecraft.bubble_coral_fan": "Boblekorallvifte",
  "block.minecraft.bubble_coral_wall_fan": "Boblekorallveggvifte",
  "block.minecraft.budding_amethyst": "Knuppande ametyst",
  "block.minecraft.bush": "Busk",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblome",
  "block.minecraft.cake": "Kake",
  "block.minecraft.calcite": "Kalkspat",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrert sculkemerkar",
  "block.minecraft.campfire": "Bål",
  "block.minecraft.candle": "Voksljos",
  "block.minecraft.candle_cake": "Kake med voksljos",
  "block.minecraft.carrots": "Gulrøter",
  "block.minecraft.cartography_table": "Kartteiknarbord",
  "block.minecraft.carved_pumpkin": "Utskore graskar",
  "block.minecraft.cauldron": "Gryte",
  "block.minecraft.cave_air": "Hòleluft",
  "block.minecraft.cave_vines": "Hengande hòlevokster",
  "block.minecraft.cave_vines_plant": "Hengande hòlevokster",
  "block.minecraft.chain": "Lenkje",
  "block.minecraft.chain_command_block": "Kjedekommandoblokk",
  "block.minecraft.cherry_button": "Kissebærknapp",
  "block.minecraft.cherry_door": "Kissebærdør",
  "block.minecraft.cherry_fence": "Kissebærgjerde",
  "block.minecraft.cherry_fence_gate": "Kissebærgrind",
  "block.minecraft.cherry_hanging_sign": "Hengande kissebærskilt",
  "block.minecraft.cherry_leaves": "Kissebærlauv",
  "block.minecraft.cherry_log": "Kissebærstomn",
  "block.minecraft.cherry_planks": "Kissebærplankar",
  "block.minecraft.cherry_pressure_plate": "Kissebærtrykkplate",
  "block.minecraft.cherry_sapling": "Kissebærrenning",
  "block.minecraft.cherry_shelf": "Kissebærhylle",
  "block.minecraft.cherry_sign": "Kissebærskilt",
  "block.minecraft.cherry_slab": "Kissebærhelle",
  "block.minecraft.cherry_stairs": "Kissebærtrapp",
  "block.minecraft.cherry_trapdoor": "Kissebærlem",
  "block.minecraft.cherry_wall_hanging_sign": "Hengande kissebærskilt på vegg",
  "block.minecraft.cherry_wall_sign": "Kissebærveggskilt",
  "block.minecraft.cherry_wood": "Kissebærtre",
  "block.minecraft.chest": "Kiste",
  "block.minecraft.chipped_anvil": "Sprokke smieste",
  "block.minecraft.chiseled_bookshelf": "Forma bokhylle",
  "block.minecraft.chiseled_copper": "Forma kopar",
  "block.minecraft.chiseled_deepslate": "Forma djupskifer",
  "block.minecraft.chiseled_nether_bricks": "Forma nethertegl",
  "block.minecraft.chiseled_polished_blackstone": "Forma finpussa svartstein",
  "block.minecraft.chiseled_quartz_block": "Forma kvarts",
  "block.minecraft.chiseled_red_sandstone": "Forma raud sandstein",
  "block.minecraft.chiseled_resin_bricks": "Forma kvaetegl",
  "block.minecraft.chiseled_sandstone": "Forma sandstein",
  "block.minecraft.chiseled_stone_bricks": "Forma steinmur",
  "block.minecraft.chiseled_tuff": "Forma tuff",
  "block.minecraft.chiseled_tuff_bricks": "Forma tufftegl",
  "block.minecraft.chorus_flower": "Korblome",
  "block.minecraft.chorus_plant": "Korvokster",
  "block.minecraft.clay": "Leire",
  "block.minecraft.closed_eyeblossom": "Attlaten augblom",
  "block.minecraft.coal_block": "Kolblokk",
  "block.minecraft.coal_ore": "Kolmalm",
  "block.minecraft.coarse_dirt": "Grov mold",
  "block.minecraft.cobbled_deepslate": "Djupskifer-brustein",
  "block.minecraft.cobbled_deepslate_slab": "Helle av djupskifer-brustein",
  "block.minecraft.cobbled_deepslate_stairs": "Trapp av djupskifer-brustein",
  "block.minecraft.cobbled_deepslate_wall": "Mur av djupskifer-brustein",
  "block.minecraft.cobblestone": "Brustein",
  "block.minecraft.cobblestone_slab": "Brusteinhelle",
  "block.minecraft.cobblestone_stairs": "Brusteintrapp",
  "block.minecraft.cobblestone_wall": "Brusteinsmur",
  "block.minecraft.cobweb": "Spinn",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Kommandoblokk",
  "block.minecraft.comparator": "Redstone-samanliknar",
  "block.minecraft.composter": "Kompostbing",
  "block.minecraft.conduit": "Flødar",
  "block.minecraft.copper_bars": "Kopargitter",
  "block.minecraft.copper_block": "Koparblokk",
  "block.minecraft.copper_bulb": "Koparpære",
  "block.minecraft.copper_chain": "Koparlenkje",
  "block.minecraft.copper_chest": "Koparkiste",
  "block.minecraft.copper_door": "Kopardør",
  "block.minecraft.copper_golem_statue": "Koparkallstytte",
  "block.minecraft.copper_grate": "Koparrist",
  "block.minecraft.copper_lantern": "Koparlykt",
  "block.minecraft.copper_ore": "Koparmalm",
  "block.minecraft.copper_torch": "Koparfakkel",
  "block.minecraft.copper_trapdoor": "Koparlem",
  "block.minecraft.copper_wall_torch": "Koparveggfakkel",
  "block.minecraft.cornflower": "Kornblom",
  "block.minecraft.cracked_deepslate_bricks": "Sprokken djupskifertegl",
  "block.minecraft.cracked_deepslate_tiles": "Sprokkne djupskiferfliser",
  "block.minecraft.cracked_nether_bricks": "Sprokke nethertegl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sprokke finpussa svartsteinstegl",
  "block.minecraft.cracked_stone_bricks": "Sprokken steinmur",
  "block.minecraft.crafter": "Emnar",
  "block.minecraft.crafting_table": "Emningsbord",
  "block.minecraft.creaking_heart": "Knirkehjarta",
  "block.minecraft.creeper_head": "Creeperhovud",
  "block.minecraft.creeper_wall_head": "Creepervegghovud",
  "block.minecraft.crimson_button": "Blodknapp",
  "block.minecraft.crimson_door": "Bloddør",
  "block.minecraft.crimson_fence": "Blodgjerde",
  "block.minecraft.crimson_fence_gate": "Blodgrind",
  "block.minecraft.crimson_fungus": "Blodsopp",
  "block.minecraft.crimson_hanging_sign": "Hengande blodskilt",
  "block.minecraft.crimson_hyphae": "Blodhyfar",
  "block.minecraft.crimson_nylium": "Blodnycel",
  "block.minecraft.crimson_planks": "Blodplankar",
  "block.minecraft.crimson_pressure_plate": "Blodtrykkplate",
  "block.minecraft.crimson_roots": "Blodrøter",
  "block.minecraft.crimson_shelf": "Blodhylle",
  "block.minecraft.crimson_sign": "Blodskilt",
  "block.minecraft.crimson_slab": "Blodhelle",
  "block.minecraft.crimson_stairs": "Blodtrapp",
  "block.minecraft.crimson_stem": "Blodstomn",
  "block.minecraft.crimson_trapdoor": "Blodlem",
  "block.minecraft.crimson_wall_hanging_sign": "Hengande blodskilt på vegg",
  "block.minecraft.crimson_wall_sign": "Blodveggskilt",
  "block.minecraft.crying_obsidian": "Gråtande obsidian",
  "block.minecraft.cut_copper": "Skoren kopar",
  "block.minecraft.cut_copper_slab": "Heller av skoren kopar",
  "block.minecraft.cut_copper_stairs": "Trapp av skoren kopar",
  "block.minecraft.cut_red_sandstone": "Skoren raud sandstein",
  "block.minecraft.cut_red_sandstone_slab": "Helle av skoren raud sandstein",
  "block.minecraft.cut_sandstone": "Skoren sandstein",
  "block.minecraft.cut_sandstone_slab": "Helle av skoren sandstein",
  "block.minecraft.cyan_banner": "Blågrøn fane",
  "block.minecraft.cyan_bed": "Blågrøn seng",
  "block.minecraft.cyan_candle": "Blågrønt voksljos",
  "block.minecraft.cyan_candle_cake": "Kake med blågrønt voksljos",
  "block.minecraft.cyan_carpet": "Blågrønt golvteppe",
  "block.minecraft.cyan_concrete": "Blågrøn betong",
  "block.minecraft.cyan_concrete_powder": "Blågrønt betongpulver",
  "block.minecraft.cyan_glazed_terracotta": "Blågrøn glasert terrakotta",
  "block.minecraft.cyan_shulker_box": "Blågrøn shulkerboks",
  "block.minecraft.cyan_stained_glass": "Blågrønt glas",
  "block.minecraft.cyan_stained_glass_pane": "Blågrøn glasrute",
  "block.minecraft.cyan_terracotta": "Blågrøn terrakotta",
  "block.minecraft.cyan_wool": "Blågrøn ull",
  "block.minecraft.damaged_anvil": "Skadd smieste",
  "block.minecraft.dandelion": "Løvetann",
  "block.minecraft.dark_oak_button": "Mørkeikeknapp",
  "block.minecraft.dark_oak_door": "Mørkeikedør",
  "block.minecraft.dark_oak_fence": "Gjerde av mørkeik",
  "block.minecraft.dark_oak_fence_gate": "Grind av mørkeik",
  "block.minecraft.dark_oak_hanging_sign": "Hengande mørkeikeskilt",
  "block.minecraft.dark_oak_leaves": "Mørkeikelauv",
  "block.minecraft.dark_oak_log": "Mørkeikestomn",
  "block.minecraft.dark_oak_planks": "Mørkeikeplankar",
  "block.minecraft.dark_oak_pressure_plate": "Mørkeiketrykkplate",
  "block.minecraft.dark_oak_sapling": "Mørkeikerenning",
  "block.minecraft.dark_oak_shelf": "Mørkeikehylle",
  "block.minecraft.dark_oak_sign": "Mørkeikeskilt",
  "block.minecraft.dark_oak_slab": "Mørkeikehelle",
  "block.minecraft.dark_oak_stairs": "Mørkeiketrapp",
  "block.minecraft.dark_oak_trapdoor": "Mørkeikelem",
  "block.minecraft.dark_oak_wall_hanging_sign": "Hengande mørkeikeskilt på vegg",
  "block.minecraft.dark_oak_wall_sign": "Mørkeikeveggskilt",
  "block.minecraft.dark_oak_wood": "Mørkeiketre",
  "block.minecraft.dark_prismarine": "Mørk prismarin",
  "block.minecraft.dark_prismarine_slab": "Mørk prismarinhelle",
  "block.minecraft.dark_prismarine_stairs": "Mørk prismarintrapp",
  "block.minecraft.daylight_detector": "Dagsljosmålar",
  "block.minecraft.dead_brain_coral": "Daud hjernekorall",
  "block.minecraft.dead_brain_coral_block": "Daud hjernekorallblokk",
  "block.minecraft.dead_brain_coral_fan": "Daud hjernkorallvifte",
  "block.minecraft.dead_brain_coral_wall_fan": "Daud hjernekorallveggvifte",
  "block.minecraft.dead_bubble_coral": "Daud boblekorall",
  "block.minecraft.dead_bubble_coral_block": "Daud boblekorallblokk",
  "block.minecraft.dead_bubble_coral_fan": "Daud boblekorallvifte",
  "block.minecraft.dead_bubble_coral_wall_fan": "Daud boblekorallveggvifte",
  "block.minecraft.dead_bush": "Daud busk",
  "block.minecraft.dead_fire_coral": "Daud eldkorall",
  "block.minecraft.dead_fire_coral_block": "Daud eldkorallblokk",
  "block.minecraft.dead_fire_coral_fan": "Daud eldkorallvifte",
  "block.minecraft.dead_fire_coral_wall_fan": "Daud eldkorallveggvifte",
  "block.minecraft.dead_horn_coral": "Daud hornkorall",
  "block.minecraft.dead_horn_coral_block": "Daud hornkorallblokk",
  "block.minecraft.dead_horn_coral_fan": "Daud hornkorallvifte",
  "block.minecraft.dead_horn_coral_wall_fan": "Daud hornkorallveggvifte",
  "block.minecraft.dead_tube_coral": "Daud orgelkorall",
  "block.minecraft.dead_tube_coral_block": "Daud orgelkorallblokk",
  "block.minecraft.dead_tube_coral_fan": "Daud orgelkorallvifte",
  "block.minecraft.dead_tube_coral_wall_fan": "Daud orgelkorallveggvifte",
  "block.minecraft.decorated_pot": "Prydd potte",
  "block.minecraft.deepslate": "Djupskifer",
  "block.minecraft.deepslate_brick_slab": "Helle av djupskifertegl",
  "block.minecraft.deepslate_brick_stairs": "Trapp av djupskifertegl",
  "block.minecraft.deepslate_brick_wall": "Mur av djupskifertegl",
  "block.minecraft.deepslate_bricks": "Djupskifertegl",
  "block.minecraft.deepslate_coal_ore": "Kolmalm i djupskifer",
  "block.minecraft.deepslate_copper_ore": "Koparmalm i djupskifer",
  "block.minecraft.deepslate_diamond_ore": "Diamant i djupskifer",
  "block.minecraft.deepslate_emerald_ore": "Smaragdmalm i djupskifer",
  "block.minecraft.deepslate_gold_ore": "Gullmalm i djupskifer",
  "block.minecraft.deepslate_iron_ore": "Jarnmalm i djupskifer",
  "block.minecraft.deepslate_lapis_ore": "Lasursteinmalm i djupskifer",
  "block.minecraft.deepslate_redstone_ore": "Redstonemalm i djupskifer",
  "block.minecraft.deepslate_tile_slab": "Helle av djupskiferfliser",
  "block.minecraft.deepslate_tile_stairs": "Trapp av djupskiferfliser",
  "block.minecraft.deepslate_tile_wall": "Mur av djupskiferfliser",
  "block.minecraft.deepslate_tiles": "Djupskiferfliser",
  "block.minecraft.detector_rail": "Detektorskjene",
  "block.minecraft.diamond_block": "Diamantblokk",
  "block.minecraft.diamond_ore": "Diamantmalm",
  "block.minecraft.diorite": "Dioritt",
  "block.minecraft.diorite_slab": "Dioritthelle",
  "block.minecraft.diorite_stairs": "Diorittrapp",
  "block.minecraft.diorite_wall": "Diorittmur",
  "block.minecraft.dirt": "Mold",
  "block.minecraft.dirt_path": "Moldrås",
  "block.minecraft.dispenser": "Utskytar",
  "block.minecraft.dragon_egg": "Drakeegg",
  "block.minecraft.dragon_head": "Drakehovud",
  "block.minecraft.dragon_wall_head": "Drakevegghovud",
  "block.minecraft.dried_ghast": "Utturka ghast",
  "block.minecraft.dried_kelp_block": "Blokk av turka tare",
  "block.minecraft.dripstone_block": "Dropsteinsblokk",
  "block.minecraft.dropper": "Sleppar",
  "block.minecraft.emerald_block": "Smaragdblokk",
  "block.minecraft.emerald_ore": "Smaragdmalm",
  "block.minecraft.enchanting_table": "Galdrebord",
  "block.minecraft.end_gateway": "Endeport",
  "block.minecraft.end_portal": "Endeportal",
  "block.minecraft.end_portal_frame": "Endeportalramme",
  "block.minecraft.end_rod": "Endestong",
  "block.minecraft.end_stone": "Endestein",
  "block.minecraft.end_stone_brick_slab": "Helle av endesteinstegl",
  "block.minecraft.end_stone_brick_stairs": "Trapp av endesteinstegl",
  "block.minecraft.end_stone_brick_wall": "Mur av endesteinstegl",
  "block.minecraft.end_stone_bricks": "Endesteinstegl",
  "block.minecraft.ender_chest": "Enderkiste",
  "block.minecraft.exposed_chiseled_copper": "Utsett forma kopar",
  "block.minecraft.exposed_copper": "Utsett kopar",
  "block.minecraft.exposed_copper_bars": "Utsett kopargitter",
  "block.minecraft.exposed_copper_bulb": "Utsett koparpære",
  "block.minecraft.exposed_copper_chain": "Utsett koparlenkje",
  "block.minecraft.exposed_copper_chest": "Utsett koparkiste",
  "block.minecraft.exposed_copper_door": "Utsett kopardør",
  "block.minecraft.exposed_copper_golem_statue": "Utsett koparkallstytte",
  "block.minecraft.exposed_copper_grate": "Utsett koparrist",
  "block.minecraft.exposed_copper_lantern": "Utsett koparlykt",
  "block.minecraft.exposed_copper_trapdoor": "Utsett koparlem",
  "block.minecraft.exposed_cut_copper": "Utsett skoren kopar",
  "block.minecraft.exposed_cut_copper_slab": "Utsett helle av skoren kopar",
  "block.minecraft.exposed_cut_copper_stairs": "Utsett trapp av skoren kopar",
  "block.minecraft.exposed_lightning_rod": "Utsett lynavleiar",
  "block.minecraft.farmland": "Åker",
  "block.minecraft.fern": "Burkne",
  "block.minecraft.fire": "Eld",
  "block.minecraft.fire_coral": "Eldkorall",
  "block.minecraft.fire_coral_block": "Eldkorallblokk",
  "block.minecraft.fire_coral_fan": "Eldkorallvifte",
  "block.minecraft.fire_coral_wall_fan": "Eldkorallveggvifte",
  "block.minecraft.firefly_bush": "Eldflugebusk",
  "block.minecraft.fletching_table": "Pilmakarbord",
  "block.minecraft.flower_pot": "Blomsterpotte",
  "block.minecraft.flowering_azalea": "Blømande lyngrose",
  "block.minecraft.flowering_azalea_leaves": "Blømande lyngroselauv",
  "block.minecraft.frogspawn": "Froskegot",
  "block.minecraft.frosted_ice": "Frosta is",
  "block.minecraft.furnace": "Omn",
  "block.minecraft.gilded_blackstone": "Gylt svartstein",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasrute",
  "block.minecraft.glow_lichen": "Glødelav",
  "block.minecraft.glowstone": "Glødestein",
  "block.minecraft.gold_block": "Gullblokk",
  "block.minecraft.gold_ore": "Gullmalm",
  "block.minecraft.golden_dandelion": "Gull-løvetann",
  "block.minecraft.granite": "Granitt",
  "block.minecraft.granite_slab": "Granitthelle",
  "block.minecraft.granite_stairs": "Granittrapp",
  "block.minecraft.granite_wall": "Granittmur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblokk",
  "block.minecraft.gravel": "Grus",
  "block.minecraft.gray_banner": "Grå fane",
  "block.minecraft.gray_bed": "Grå seng",
  "block.minecraft.gray_candle": "Grått voksljos",
  "block.minecraft.gray_candle_cake": "Kake med grått voksljos",
  "block.minecraft.gray_carpet": "Grått golvteppe",
  "block.minecraft.gray_concrete": "Grå betong",
  "block.minecraft.gray_concrete_powder": "Grått betongpulver",
  "block.minecraft.gray_glazed_terracotta": "Grå glasert terrakotta",
  "block.minecraft.gray_shulker_box": "Grå shulkerboks",
  "block.minecraft.gray_stained_glass": "Grått glas",
  "block.minecraft.gray_stained_glass_pane": "Grå glasrute",
  "block.minecraft.gray_terracotta": "Grå terrakotta",
  "block.minecraft.gray_wool": "Grå ull",
  "block.minecraft.green_banner": "Grøn fane",
  "block.minecraft.green_bed": "Grøn seng",
  "block.minecraft.green_candle": "Grønt voksljos",
  "block.minecraft.green_candle_cake": "Kake med grønt voksljos",
  "block.minecraft.green_carpet": "Grønt golvteppe",
  "block.minecraft.green_concrete": "Grøn betong",
  "block.minecraft.green_concrete_powder": "Grønt betongpulver",
  "block.minecraft.green_glazed_terracotta": "Grøn glasert terrakotta",
  "block.minecraft.green_shulker_box": "Grøn shulkerboks",
  "block.minecraft.green_stained_glass": "Grønt glas",
  "block.minecraft.green_stained_glass_pane": "Grøn glasrute",
  "block.minecraft.green_terracotta": "Grøn terrakotta",
  "block.minecraft.green_wool": "Grøn ull",
  "block.minecraft.grindstone": "Slipestein",
  "block.minecraft.hanging_roots": "Hengande røter",
  "block.minecraft.hay_block": "Høystakk",
  "block.minecraft.heavy_core": "Tung kjerne",
  "block.minecraft.heavy_weighted_pressure_plate": "Tung tyngdetrykkplate",
  "block.minecraft.honey_block": "Honningblokk",
  "block.minecraft.honeycomb_block": "Vokskakeblokk",
  "block.minecraft.hopper": "Trekt",
  "block.minecraft.horn_coral": "Hornkorall",
  "block.minecraft.horn_coral_block": "Hornkorallblokk",
  "block.minecraft.horn_coral_fan": "Hornkorallvifte",
  "block.minecraft.horn_coral_wall_fan": "Hornkorallveggvifte",
  "block.minecraft.ice": "Is",
  "block.minecraft.infested_chiseled_stone_bricks": "Fengd forma steinmur",
  "block.minecraft.infested_cobblestone": "Fengd brustein",
  "block.minecraft.infested_cracked_stone_bricks": "Fengd sprokken steinmur",
  "block.minecraft.infested_deepslate": "Fengd djupskifer",
  "block.minecraft.infested_mossy_stone_bricks": "Fengd mosegrodd steinmur",
  "block.minecraft.infested_stone": "Fengd stein",
  "block.minecraft.infested_stone_bricks": "Fengd steinmur",
  "block.minecraft.iron_bars": "Gitter",
  "block.minecraft.iron_block": "Jarnblokk",
  "block.minecraft.iron_chain": "Jarnlenkje",
  "block.minecraft.iron_door": "Jarndør",
  "block.minecraft.iron_ore": "Jarnmalm",
  "block.minecraft.iron_trapdoor": "Jarnlem",
  "block.minecraft.jack_o_lantern": "Graskarlykt",
  "block.minecraft.jigsaw": "Pusleblokk",
  "block.minecraft.jukebox": "Platespelar",
  "block.minecraft.jungle_button": "Jungeltreknapp",
  "block.minecraft.jungle_door": "Jungeltredør",
  "block.minecraft.jungle_fence": "Gjerde av jungeltre",
  "block.minecraft.jungle_fence_gate": "Grind av jungeltre",
  "block.minecraft.jungle_hanging_sign": "Hengande jungeltreskilt",
  "block.minecraft.jungle_leaves": "Jungellauv",
  "block.minecraft.jungle_log": "Jungeltrestomn",
  "block.minecraft.jungle_planks": "Jungeltreplankar",
  "block.minecraft.jungle_pressure_plate": "Jungeltretrykkplate",
  "block.minecraft.jungle_sapling": "Jungeltrerenning",
  "block.minecraft.jungle_shelf": "Jungeltrehylle",
  "block.minecraft.jungle_sign": "Jungeltreskilt",
  "block.minecraft.jungle_slab": "Jungeltrehelle",
  "block.minecraft.jungle_stairs": "Jungeltretrapp",
  "block.minecraft.jungle_trapdoor": "Jungeltrelem",
  "block.minecraft.jungle_wall_hanging_sign": "Hengande jungeltreskilt på vegg",
  "block.minecraft.jungle_wall_sign": "Jungeltreveggskilt",
  "block.minecraft.jungle_wood": "Jungeltre",
  "block.minecraft.kelp": "Tare",
  "block.minecraft.kelp_plant": "Tarevokster",
  "block.minecraft.ladder": "Stige",
  "block.minecraft.lantern": "Lykt",
  "block.minecraft.lapis_block": "Blokk av lasurstein",
  "block.minecraft.lapis_ore": "Malm av lasurstein",
  "block.minecraft.large_amethyst_bud": "Stor ametystblokk",
  "block.minecraft.large_fern": "Stor burkne",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavagryte",
  "block.minecraft.leaf_litter": "Lauvstrøy",
  "block.minecraft.lectern": "Talarstol",
  "block.minecraft.lever": "Spak",
  "block.minecraft.light": "Ljos",
  "block.minecraft.light_blue_banner": "Ljosblå fane",
  "block.minecraft.light_blue_bed": "Ljosblå seng",
  "block.minecraft.light_blue_candle": "Ljosblått voksljos",
  "block.minecraft.light_blue_candle_cake": "Kake med ljosblått voksljos",
  "block.minecraft.light_blue_carpet": "Ljosblått golvteppe",
  "block.minecraft.light_blue_concrete": "Ljosblå betong",
  "block.minecraft.light_blue_concrete_powder": "Ljosblått betongpulver",
  "block.minecraft.light_blue_glazed_terracotta": "Ljosblå glasert terrakotta",
  "block.minecraft.light_blue_shulker_box": "Ljosblå shulkerboks",
  "block.minecraft.light_blue_stained_glass": "Ljosblått glas",
  "block.minecraft.light_blue_stained_glass_pane": "Ljosblå glasrute",
  "block.minecraft.light_blue_terracotta": "Ljosblå terrakotta",
  "block.minecraft.light_blue_wool": "Ljosblå ull",
  "block.minecraft.light_gray_banner": "Ljosgrå fane",
  "block.minecraft.light_gray_bed": "Ljosgrå seng",
  "block.minecraft.light_gray_candle": "Ljosgrått voksljos",
  "block.minecraft.light_gray_candle_cake": "Kake med ljosgrått voksljos",
  "block.minecraft.light_gray_carpet": "Ljosgrått golvteppe",
  "block.minecraft.light_gray_concrete": "Ljosgrå betong",
  "block.minecraft.light_gray_concrete_powder": "Ljosgrått betongpulver",
  "block.minecraft.light_gray_glazed_terracotta": "Ljosgrå glasert terrakotta",
  "block.minecraft.light_gray_shulker_box": "Ljosgrå shulkerboks",
  "block.minecraft.light_gray_stained_glass": "Ljosgrått glas",
  "block.minecraft.light_gray_stained_glass_pane": "Ljosgrå glasrute",
  "block.minecraft.light_gray_terracotta": "Ljosgrå terrakotta",
  "block.minecraft.light_gray_wool": "Ljosgrå ull",
  "block.minecraft.light_weighted_pressure_plate": "Lett tyngdetrykkplate",
  "block.minecraft.lightning_rod": "Lynavleiar",
  "block.minecraft.lilac": "Syrin",
  "block.minecraft.lily_of_the_valley": "Rams",
  "block.minecraft.lily_pad": "Liljeblad",
  "block.minecraft.lime_banner": "Limegrøn fane",
  "block.minecraft.lime_bed": "Limegrøn seng",
  "block.minecraft.lime_candle": "Limegrønt voksljos",
  "block.minecraft.lime_candle_cake": "Kake med limegrønt voksljos",
  "block.minecraft.lime_carpet": "Limegrønt golvteppe",
  "block.minecraft.lime_concrete": "Limegrøn betong",
  "block.minecraft.lime_concrete_powder": "Limegrønt betongpulver",
  "block.minecraft.lime_glazed_terracotta": "Limegrøn glasert terrakotta",
  "block.minecraft.lime_shulker_box": "Limegrøn shulkerboks",
  "block.minecraft.lime_stained_glass": "Limegrønt glas",
  "block.minecraft.lime_stained_glass_pane": "Limegrøn glasrute",
  "block.minecraft.lime_terracotta": "Limegrøn terrakotta",
  "block.minecraft.lime_wool": "Limegrøn ull",
  "block.minecraft.lodestone": "Leidarstein",
  "block.minecraft.loom": "Vevstol",
  "block.minecraft.magenta_banner": "Ljoslilla fane",
  "block.minecraft.magenta_bed": "Ljoslilla seng",
  "block.minecraft.magenta_candle": "Ljoslilla voksljos",
  "block.minecraft.magenta_candle_cake": "Kake med ljoslilla voksljos",
  "block.minecraft.magenta_carpet": "Ljoslilla golvteppe",
  "block.minecraft.magenta_concrete": "Ljoslilla betong",
  "block.minecraft.magenta_concrete_powder": "Ljoslilla betongpulver",
  "block.minecraft.magenta_glazed_terracotta": "Ljoslilla glasert terrakotta",
  "block.minecraft.magenta_shulker_box": "Ljoslilla shulkerboks",
  "block.minecraft.magenta_stained_glass": "Ljoslilla glas",
  "block.minecraft.magenta_stained_glass_pane": "Ljoslilla glasrute",
  "block.minecraft.magenta_terracotta": "Ljoslilla terrakotta",
  "block.minecraft.magenta_wool": "Ljoslilla ull",
  "block.minecraft.magma_block": "Magmablokk",
  "block.minecraft.mangrove_button": "Mangroveknapp",
  "block.minecraft.mangrove_door": "Mangrovedør",
  "block.minecraft.mangrove_fence": "Mangrovegjerde",
  "block.minecraft.mangrove_fence_gate": "Mangrovegrind",
  "block.minecraft.mangrove_hanging_sign": "Hengande mangroveskilt",
  "block.minecraft.mangrove_leaves": "Mangrovelauv",
  "block.minecraft.mangrove_log": "Mangrovestomn",
  "block.minecraft.mangrove_planks": "Mangroveplankar",
  "block.minecraft.mangrove_pressure_plate": "Mangrovetrykkplate",
  "block.minecraft.mangrove_propagule": "Mangrovefrø",
  "block.minecraft.mangrove_roots": "Mangroverøter",
  "block.minecraft.mangrove_shelf": "Mangrovehylle",
  "block.minecraft.mangrove_sign": "Mangroveskilt",
  "block.minecraft.mangrove_slab": "Mangrovehelle",
  "block.minecraft.mangrove_stairs": "Mangrovetrapp",
  "block.minecraft.mangrove_trapdoor": "Mangrovelem",
  "block.minecraft.mangrove_wall_hanging_sign": "Hengande mangroveskilt på vegg",
  "block.minecraft.mangrove_wall_sign": "Mangroveveggskilt",
  "block.minecraft.mangrove_wood": "Mangrovetre",
  "block.minecraft.medium_amethyst_bud": "Mellomstor ametystblokk",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melonstilk",
  "block.minecraft.moss_block": "Moseblokk",
  "block.minecraft.moss_carpet": "Mosebreisle",
  "block.minecraft.mossy_cobblestone": "Mosegrodd brustein",
  "block.minecraft.mossy_cobblestone_slab": "Mosegrodd brusteinshelle",
  "block.minecraft.mossy_cobblestone_stairs": "Mosegrodd brusteinstrapp",
  "block.minecraft.mossy_cobblestone_wall": "Mosegrodd brusteinsmur",
  "block.minecraft.mossy_stone_brick_slab": "Mosegrodd helle av steintegl",
  "block.minecraft.mossy_stone_brick_stairs": "Mosegrodd trapp av steintegl",
  "block.minecraft.mossy_stone_brick_wall": "Mosegrodd mur av steintegl",
  "block.minecraft.mossy_stone_bricks": "Mosegrodd steinmur",
  "block.minecraft.moving_piston": "Rørande stempel",
  "block.minecraft.mud": "Gjørme",
  "block.minecraft.mud_brick_slab": "Helle av gjørmetegl",
  "block.minecraft.mud_brick_stairs": "Trapp av gjørmetegl",
  "block.minecraft.mud_brick_wall": "Mur av gjørmetegl",
  "block.minecraft.mud_bricks": "Gjørmetegl",
  "block.minecraft.muddy_mangrove_roots": "Gjørmete mangroverøter",
  "block.minecraft.mushroom_stem": "Soppstilk",
  "block.minecraft.mycelium": "Mycel",
  "block.minecraft.nether_brick_fence": "Gjerde av nethertegl",
  "block.minecraft.nether_brick_slab": "Helle av nethertegl",
  "block.minecraft.nether_brick_stairs": "Trapp av nethertegl",
  "block.minecraft.nether_brick_wall": "Mur av nethertegl",
  "block.minecraft.nether_bricks": "Nethertegl",
  "block.minecraft.nether_gold_ore": "Nethergullmalm",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Malm av nether-kvarts",
  "block.minecraft.nether_sprouts": "Netherspirer",
  "block.minecraft.nether_wart": "Nethervorte",
  "block.minecraft.nether_wart_block": "Vorteblokk",
  "block.minecraft.netherite_block": "Netherittblokk",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noteblokk",
  "block.minecraft.oak_button": "Eikeknapp",
  "block.minecraft.oak_door": "Eikedør",
  "block.minecraft.oak_fence": "Gjerde av eik",
  "block.minecraft.oak_fence_gate": "Grind av eik",
  "block.minecraft.oak_hanging_sign": "Hengande eikeskilt",
  "block.minecraft.oak_leaves": "Eikelauv",
  "block.minecraft.oak_log": "Eikestomn",
  "block.minecraft.oak_planks": "Eikeplankar",
  "block.minecraft.oak_pressure_plate": "Eiketrykkplate",
  "block.minecraft.oak_sapling": "Eikerenning",
  "block.minecraft.oak_shelf": "Eikehylle",
  "block.minecraft.oak_sign": "Eikeskilt",
  "block.minecraft.oak_slab": "Eikehelle",
  "block.minecraft.oak_stairs": "Eiketrapp",
  "block.minecraft.oak_trapdoor": "Eikelem",
  "block.minecraft.oak_wall_hanging_sign": "Hengande eikeskilt på vegg",
  "block.minecraft.oak_wall_sign": "Eikeveggskilt",
  "block.minecraft.oak_wood": "Eiketre",
  "block.minecraft.observer": "Utkikar",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Gulbrunt froskeljos",
  "block.minecraft.ominous_banner": "Illevarande fane",
  "block.minecraft.open_eyeblossom": "Open augblom",
  "block.minecraft.orange_banner": "Oransje fane",
  "block.minecraft.orange_bed": "Oransje seng",
  "block.minecraft.orange_candle": "Oransje voksljos",
  "block.minecraft.orange_candle_cake": "Kake med oransje voksljos",
  "block.minecraft.orange_carpet": "Oransje golvteppe",
  "block.minecraft.orange_concrete": "Oransje betong",
  "block.minecraft.orange_concrete_powder": "Oransje betongpulver",
  "block.minecraft.orange_glazed_terracotta": "Oransje glasert terrakotta",
  "block.minecraft.orange_shulker_box": "Oransje shulkerboks",
  "block.minecraft.orange_stained_glass": "Oransje glas",
  "block.minecraft.orange_stained_glass_pane": "Oransje glasrute",
  "block.minecraft.orange_terracotta": "Branngul terrakotta",
  "block.minecraft.orange_tulip": "Oransje tulipan",
  "block.minecraft.orange_wool": "Oransje ull",
  "block.minecraft.oxeye_daisy": "Prestekrage",
  "block.minecraft.oxidized_chiseled_copper": "Eira forma kopar",
  "block.minecraft.oxidized_copper": "Eira koparblokk",
  "block.minecraft.oxidized_copper_bars": "Eira kopargitter",
  "block.minecraft.oxidized_copper_bulb": "Eira koparpære",
  "block.minecraft.oxidized_copper_chain": "Eira koparlenkje",
  "block.minecraft.oxidized_copper_chest": "Eira koparkiste",
  "block.minecraft.oxidized_copper_door": "Eira kopardør",
  "block.minecraft.oxidized_copper_golem_statue": "Eira koparkallstytte",
  "block.minecraft.oxidized_copper_grate": "Eira koparrist",
  "block.minecraft.oxidized_copper_lantern": "Eira koparlykt",
  "block.minecraft.oxidized_copper_trapdoor": "Eira koparlem",
  "block.minecraft.oxidized_cut_copper": "Eira skoren kopar",
  "block.minecraft.oxidized_cut_copper_slab": "Eira helle av skoren kopar",
  "block.minecraft.oxidized_cut_copper_stairs": "Eira trapp av skoren kopar",
  "block.minecraft.oxidized_lightning_rod": "Eira lynavleiar",
  "block.minecraft.packed_ice": "Pakkis",
  "block.minecraft.packed_mud": "Pakkgjørme",
  "block.minecraft.pale_hanging_moss": "Hengande bleikmose",
  "block.minecraft.pale_moss_block": "Bleikmoseblokk",
  "block.minecraft.pale_moss_carpet": "Bleikmoseteppe",
  "block.minecraft.pale_oak_button": "Bleikeikeknapp",
  "block.minecraft.pale_oak_door": "Bleikeikedør",
  "block.minecraft.pale_oak_fence": "Bleikeikegard",
  "block.minecraft.pale_oak_fence_gate": "Bleikeikegrind",
  "block.minecraft.pale_oak_hanging_sign": "Hengande bleikeikeskilt",
  "block.minecraft.pale_oak_leaves": "Bleikeikelauv",
  "block.minecraft.pale_oak_log": "Bleikeikestomn",
  "block.minecraft.pale_oak_planks": "Bleikeikeplankar",
  "block.minecraft.pale_oak_pressure_plate": "Bleikeiketrykkplate",
  "block.minecraft.pale_oak_sapling": "Bleikeikerenning",
  "block.minecraft.pale_oak_shelf": "Bleikeikehylle",
  "block.minecraft.pale_oak_sign": "Bleikeikeskilt",
  "block.minecraft.pale_oak_slab": "Bleikeikehelle",
  "block.minecraft.pale_oak_stairs": "Bleikeiketrapp",
  "block.minecraft.pale_oak_trapdoor": "Bleikeikelem",
  "block.minecraft.pale_oak_wall_hanging_sign": "Hengande bleikeikeskilt på vegg",
  "block.minecraft.pale_oak_wall_sign": "Bleikeikeveggskilt",
  "block.minecraft.pale_oak_wood": "Bleikeiketre",
  "block.minecraft.pearlescent_froglight": "Perleskimrande froskeljos",
  "block.minecraft.peony": "Pion",
  "block.minecraft.petrified_oak_slab": "Forsteina eikehelle",
  "block.minecraft.piglin_head": "Piglinhovud",
  "block.minecraft.piglin_wall_head": "Piglinvegghovud",
  "block.minecraft.pink_banner": "Rosa fane",
  "block.minecraft.pink_bed": "Rosa seng",
  "block.minecraft.pink_candle": "Rosa voksljos",
  "block.minecraft.pink_candle_cake": "Kake med rosa voksljos",
  "block.minecraft.pink_carpet": "Rosa golvteppe",
  "block.minecraft.pink_concrete": "Rosa betong",
  "block.minecraft.pink_concrete_powder": "Rosa betongpulver",
  "block.minecraft.pink_glazed_terracotta": "Rosa glasert terrakotta",
  "block.minecraft.pink_petals": "Ljosraude kronblad",
  "block.minecraft.pink_shulker_box": "Rosa shulkerboks",
  "block.minecraft.pink_stained_glass": "Rosa glas",
  "block.minecraft.pink_stained_glass_pane": "Rosa glasrute",
  "block.minecraft.pink_terracotta": "Rosa terrakotta",
  "block.minecraft.pink_tulip": "Rosa tulipan",
  "block.minecraft.pink_wool": "Rosa ull",
  "block.minecraft.piston": "Stempel",
  "block.minecraft.piston_head": "Stempelhovud",
  "block.minecraft.pitcher_crop": "Krukkeavling",
  "block.minecraft.pitcher_plant": "Kanneberar",
  "block.minecraft.player_head": "Spelarhovud",
  "block.minecraft.player_head.named": "Hovudet til %s",
  "block.minecraft.player_wall_head": "Spelarvegghovud",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Kvass dropstein",
  "block.minecraft.polished_andesite": "Finpussa andesitt",
  "block.minecraft.polished_andesite_slab": "Helle av finpussa andesitt",
  "block.minecraft.polished_andesite_stairs": "Finpussa andesittrapp",
  "block.minecraft.polished_basalt": "Finpussa basalt",
  "block.minecraft.polished_blackstone": "Finpussa svartstein",
  "block.minecraft.polished_blackstone_brick_slab": "Helle av finpussa svartsteinstegl",
  "block.minecraft.polished_blackstone_brick_stairs": "Trapp av finpussa svartsteinstegl",
  "block.minecraft.polished_blackstone_brick_wall": "Mur av finpussa svartsteinstegl",
  "block.minecraft.polished_blackstone_bricks": "Finpussa svartsteinstegl",
  "block.minecraft.polished_blackstone_button": "Knapp av finpussa svartstein",
  "block.minecraft.polished_blackstone_pressure_plate": "Trykkplate av finpussa svartstein",
  "block.minecraft.polished_blackstone_slab": "Helle av finpussa svartstein",
  "block.minecraft.polished_blackstone_stairs": "Trapp av finpussa svartstein",
  "block.minecraft.polished_blackstone_wall": "Mur av finpussa svartstein",
  "block.minecraft.polished_deepslate": "Finpussa djupskifer",
  "block.minecraft.polished_deepslate_slab": "Helle av finpussa djupskifer",
  "block.minecraft.polished_deepslate_stairs": "Trapp av finpussa djupskifer",
  "block.minecraft.polished_deepslate_wall": "Mur av finpussa djupskifer",
  "block.minecraft.polished_diorite": "Finpussa dioritt",
  "block.minecraft.polished_diorite_slab": "Finpussa dioritthelle",
  "block.minecraft.polished_diorite_stairs": "Finpussa diorittrapp",
  "block.minecraft.polished_granite": "Finpussa granitt",
  "block.minecraft.polished_granite_slab": "Finpussa granitthelle",
  "block.minecraft.polished_granite_stairs": "Finpussa granittrapp",
  "block.minecraft.polished_tuff": "Finpussa tuff",
  "block.minecraft.polished_tuff_slab": "Helle av finpussa tuff",
  "block.minecraft.polished_tuff_stairs": "Trapp av finpussa tuff",
  "block.minecraft.polished_tuff_wall": "Mur av finpussa tuff",
  "block.minecraft.poppy": "Valmue",
  "block.minecraft.potatoes": "Poteter",
  "block.minecraft.potted_acacia_sapling": "Akasierenning i potte",
  "block.minecraft.potted_allium": "Villauk i potte",
  "block.minecraft.potted_azalea_bush": "Lyngrose i potte",
  "block.minecraft.potted_azure_bluet": "Houstonia i potte",
  "block.minecraft.potted_bamboo": "Bambus i potte",
  "block.minecraft.potted_birch_sapling": "Bjørkerenning i potte",
  "block.minecraft.potted_blue_orchid": "Blå orkidé i potte",
  "block.minecraft.potted_brown_mushroom": "Brun sopp i potte",
  "block.minecraft.potted_cactus": "Kaktus i potte",
  "block.minecraft.potted_cherry_sapling": "Kissebærrenning i potte",
  "block.minecraft.potted_closed_eyeblossom": "Attlaten augblom i potte",
  "block.minecraft.potted_cornflower": "Kornblom i potte",
  "block.minecraft.potted_crimson_fungus": "Blodsopp i potte",
  "block.minecraft.potted_crimson_roots": "Blodrøter i potte",
  "block.minecraft.potted_dandelion": "Løvetann i potte",
  "block.minecraft.potted_dark_oak_sapling": "Mørkeikerenning i potte",
  "block.minecraft.potted_dead_bush": "Daud busk i potte",
  "block.minecraft.potted_fern": "Burkne i potte",
  "block.minecraft.potted_flowering_azalea_bush": "Blømande lyngrose i potte",
  "block.minecraft.potted_golden_dandelion": "Gull-løvetann i potte",
  "block.minecraft.potted_jungle_sapling": "Jungeltrerenning i potte",
  "block.minecraft.potted_lily_of_the_valley": "Rams i potte",
  "block.minecraft.potted_mangrove_propagule": "Mangrovefrø i potte",
  "block.minecraft.potted_oak_sapling": "Eikerenning i potte",
  "block.minecraft.potted_open_eyeblossom": "Open augblom i potte",
  "block.minecraft.potted_orange_tulip": "Oransje tulipan i potte",
  "block.minecraft.potted_oxeye_daisy": "Prestekrage i potte",
  "block.minecraft.potted_pale_oak_sapling": "Bleikeikerenning i potte",
  "block.minecraft.potted_pink_tulip": "Rosa tulipan i potte",
  "block.minecraft.potted_poppy": "Valmue i potte",
  "block.minecraft.potted_red_mushroom": "Flugesopp i potte",
  "block.minecraft.potted_red_tulip": "Raud tulipan i potte",
  "block.minecraft.potted_spruce_sapling": "Granrenning i potte",
  "block.minecraft.potted_torchflower": "Kyndelblom i potte",
  "block.minecraft.potted_warped_fungus": "Vridesopp i potte",
  "block.minecraft.potted_warped_roots": "Vriderøter i potte",
  "block.minecraft.potted_white_tulip": "Kvit tulipan i potte",
  "block.minecraft.potted_wither_rose": "Witherrose i potte",
  "block.minecraft.powder_snow": "Nysnø",
  "block.minecraft.powder_snow_cauldron": "Gryte med nysnø",
  "block.minecraft.powered_rail": "Straumskjene",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinmurhelle",
  "block.minecraft.prismarine_brick_stairs": "Prismarinmurtrapp",
  "block.minecraft.prismarine_bricks": "Prismarintegl",
  "block.minecraft.prismarine_slab": "Prismarinhelle",
  "block.minecraft.prismarine_stairs": "Prismarintrapp",
  "block.minecraft.prismarine_wall": "Prismarinmur",
  "block.minecraft.pumpkin": "Graskar",
  "block.minecraft.pumpkin_stem": "Graskarstilk",
  "block.minecraft.purple_banner": "Lilla fane",
  "block.minecraft.purple_bed": "Lilla seng",
  "block.minecraft.purple_candle": "Lilla voksljos",
  "block.minecraft.purple_candle_cake": "Kake med lilla voksljos",
  "block.minecraft.purple_carpet": "Lilla golvteppe",
  "block.minecraft.purple_concrete": "Lilla betong",
  "block.minecraft.purple_concrete_powder": "Lilla betongpulver",
  "block.minecraft.purple_glazed_terracotta": "Lilla glasert terrakotta",
  "block.minecraft.purple_shulker_box": "Lilla shulkerboks",
  "block.minecraft.purple_stained_glass": "Lilla glas",
  "block.minecraft.purple_stained_glass_pane": "Lilla glasrute",
  "block.minecraft.purple_terracotta": "Lilla terrakotta",
  "block.minecraft.purple_wool": "Lilla ull",
  "block.minecraft.purpur_block": "Purpurblokk",
  "block.minecraft.purpur_pillar": "Purpursøyle",
  "block.minecraft.purpur_slab": "Purpurhelle",
  "block.minecraft.purpur_stairs": "Purpurtrapp",
  "block.minecraft.quartz_block": "Blokk av kvarts",
  "block.minecraft.quartz_bricks": "Kvartstegl",
  "block.minecraft.quartz_pillar": "Kvartssøyle",
  "block.minecraft.quartz_slab": "Helle av kvarts",
  "block.minecraft.quartz_stairs": "Kvartstrapp",
  "block.minecraft.rail": "Skjene",
  "block.minecraft.raw_copper_block": "Blokk av råkopar",
  "block.minecraft.raw_gold_block": "Blokk av rågull",
  "block.minecraft.raw_iron_block": "Blokk av råjarn",
  "block.minecraft.red_banner": "Raud fane",
  "block.minecraft.red_bed": "Raud seng",
  "block.minecraft.red_candle": "Raudt voksljos",
  "block.minecraft.red_candle_cake": "Kake med raudt voksljos",
  "block.minecraft.red_carpet": "Raudt golvteppe",
  "block.minecraft.red_concrete": "Raud betong",
  "block.minecraft.red_concrete_powder": "Raudt betongpulver",
  "block.minecraft.red_glazed_terracotta": "Raud glasert terrakotta",
  "block.minecraft.red_mushroom": "Flugesopp",
  "block.minecraft.red_mushroom_block": "Flugesoppblokk",
  "block.minecraft.red_nether_brick_slab": "Helle av raud nethertegl",
  "block.minecraft.red_nether_brick_stairs": "Trapp av raud nethertegl",
  "block.minecraft.red_nether_brick_wall": "Mur av raudt nethertegl",
  "block.minecraft.red_nether_bricks": "Raudt nethertegl",
  "block.minecraft.red_sand": "Raud sand",
  "block.minecraft.red_sandstone": "Raud sandstein",
  "block.minecraft.red_sandstone_slab": "Raud sandsteinhelle",
  "block.minecraft.red_sandstone_stairs": "Raud sandsteintrapp",
  "block.minecraft.red_sandstone_wall": "Raud sandsteinsmur",
  "block.minecraft.red_shulker_box": "Raud shulkerboks",
  "block.minecraft.red_stained_glass": "Raudt glas",
  "block.minecraft.red_stained_glass_pane": "Raud glasrute",
  "block.minecraft.red_terracotta": "Raud terrakotta",
  "block.minecraft.red_tulip": "Raud tulipan",
  "block.minecraft.red_wool": "Raud ull",
  "block.minecraft.redstone_block": "Blokk av redstone",
  "block.minecraft.redstone_lamp": "Redstone-lampe",
  "block.minecraft.redstone_ore": "Redstone-malm",
  "block.minecraft.redstone_torch": "Redstone-fakkel",
  "block.minecraft.redstone_wall_torch": "Redstone-veggfakkel",
  "block.minecraft.redstone_wire": "Redstoneleidning",
  "block.minecraft.reinforced_deepslate": "Styrkt djupskifer",
  "block.minecraft.repeater": "Redstone-aukar",
  "block.minecraft.repeating_command_block": "Gjentakande kommandoblokk",
  "block.minecraft.resin_block": "Kvaeblokk",
  "block.minecraft.resin_brick_slab": "Helle av kvaetegl",
  "block.minecraft.resin_brick_stairs": "Trapp av kvaetegl",
  "block.minecraft.resin_brick_wall": "Mur av kvaetegl",
  "block.minecraft.resin_bricks": "Kvaetegl",
  "block.minecraft.resin_clump": "Kvaeklump",
  "block.minecraft.respawn_anchor": "Oppstodeanker",
  "block.minecraft.rooted_dirt": "Røtt mold",
  "block.minecraft.rose_bush": "Rosebusk",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstein",
  "block.minecraft.sandstone_slab": "Sandsteinhelle",
  "block.minecraft.sandstone_stairs": "Sandsteintrapp",
  "block.minecraft.sandstone_wall": "Sandsteinmur",
  "block.minecraft.scaffolding": "Stelling",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkeskundar",
  "block.minecraft.sculk_sensor": "Sculkemerkar",
  "block.minecraft.sculk_shrieker": "Sculkeskrikar",
  "block.minecraft.sculk_vein": "Sculkeår",
  "block.minecraft.sea_lantern": "Sjølykt",
  "block.minecraft.sea_pickle": "Sjøagurk",
  "block.minecraft.seagrass": "Sjøgras",
  "block.minecraft.set_spawn": "Sette byrjestad",
  "block.minecraft.short_dry_grass": "Stutt turt gras",
  "block.minecraft.short_grass": "Stutt gras",
  "block.minecraft.shroomlight": "Lampinjong",
  "block.minecraft.shulker_box": "Shulkerboks",
  "block.minecraft.skeleton_skull": "Skalle",
  "block.minecraft.skeleton_wall_skull": "Veggskalle",
  "block.minecraft.slime_block": "Slimblokk",
  "block.minecraft.small_amethyst_bud": "Lita ametystblokk",
  "block.minecraft.small_dripleaf": "Lite droplauv",
  "block.minecraft.smithing_table": "Smiebord",
  "block.minecraft.smoker": "Røykjaromn",
  "block.minecraft.smooth_basalt": "Glatt basalt",
  "block.minecraft.smooth_quartz": "Glatt kvartsblokk",
  "block.minecraft.smooth_quartz_slab": "Helle av glatt kvarts",
  "block.minecraft.smooth_quartz_stairs": "Glatt kvartstrapp",
  "block.minecraft.smooth_red_sandstone": "Glatt raud sandstein",
  "block.minecraft.smooth_red_sandstone_slab": "Glatt raud sandsteinshelle",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatt raud sandsteinstrapp",
  "block.minecraft.smooth_sandstone": "Glatt sandstein",
  "block.minecraft.smooth_sandstone_slab": "Helle av glatt sandstein",
  "block.minecraft.smooth_sandstone_stairs": "Glatt sandsteinstrapp",
  "block.minecraft.smooth_stone": "Glatt stein",
  "block.minecraft.smooth_stone_slab": "Glatt steinhelle",
  "block.minecraft.sniffer_egg": "Moldnaseegg",
  "block.minecraft.snow": "Snø",
  "block.minecraft.snow_block": "Snøblokk",
  "block.minecraft.soul_campfire": "Sjelebål",
  "block.minecraft.soul_fire": "Sjeleeld",
  "block.minecraft.soul_lantern": "Sjeleljos",
  "block.minecraft.soul_sand": "Sjelesand",
  "block.minecraft.soul_soil": "Sjelemold",
  "block.minecraft.soul_torch": "Sjelefakkel",
  "block.minecraft.soul_wall_torch": "Sjeleveggfakkel",
  "block.minecraft.spawn.not_valid": "Du har inga seng eller anker for oppsode, eller so vart ho/det stengd/t",
  "block.minecraft.spawner": "Skapningsframkallar",
  "block.minecraft.spawner.desc1": "Bruka framkallingsegg:",
  "block.minecraft.spawner.desc2": "Set skapningsslaget",
  "block.minecraft.sponge": "Svamp",
  "block.minecraft.spore_blossom": "Moseblome",
  "block.minecraft.spruce_button": "Granknapp",
  "block.minecraft.spruce_door": "Grandør",
  "block.minecraft.spruce_fence": "Gjerde av gran",
  "block.minecraft.spruce_fence_gate": "Grind av gran",
  "block.minecraft.spruce_hanging_sign": "Hengande granskilt",
  "block.minecraft.spruce_leaves": "Granbar",
  "block.minecraft.spruce_log": "Granstomn",
  "block.minecraft.spruce_planks": "Granplankar",
  "block.minecraft.spruce_pressure_plate": "Grantrykkplate",
  "block.minecraft.spruce_sapling": "Granrenning",
  "block.minecraft.spruce_shelf": "Granhylle",
  "block.minecraft.spruce_sign": "Granskilt",
  "block.minecraft.spruce_slab": "Granhelle",
  "block.minecraft.spruce_stairs": "Grantrapp",
  "block.minecraft.spruce_trapdoor": "Granlem",
  "block.minecraft.spruce_wall_hanging_sign": "Hengande granskilt på vegg",
  "block.minecraft.spruce_wall_sign": "Granveggskilt",
  "block.minecraft.spruce_wood": "Grantre",
  "block.minecraft.sticky_piston": "Klisterstempel",
  "block.minecraft.stone": "Stein",
  "block.minecraft.stone_brick_slab": "Steinmurhelle",
  "block.minecraft.stone_brick_stairs": "Steinmurtrapp",
  "block.minecraft.stone_brick_wall": "Mur av steintegl",
  "block.minecraft.stone_bricks": "Steinmur",
  "block.minecraft.stone_button": "Steinknapp",
  "block.minecraft.stone_pressure_plate": "Steintrykkplate",
  "block.minecraft.stone_slab": "Steinhelle",
  "block.minecraft.stone_stairs": "Steintrapp",
  "block.minecraft.stonecutter": "Steinskjerar",
  "block.minecraft.stripped_acacia_log": "Slinda akasiestomn",
  "block.minecraft.stripped_acacia_wood": "Slinda akasieved",
  "block.minecraft.stripped_bamboo_block": "Slinda bambusblokk",
  "block.minecraft.stripped_birch_log": "Slinda bjørkestomn",
  "block.minecraft.stripped_birch_wood": "Slinda bjørkeved",
  "block.minecraft.stripped_cherry_log": "Slinda kissebærstomn",
  "block.minecraft.stripped_cherry_wood": "Slinda kissebærved",
  "block.minecraft.stripped_crimson_hyphae": "Slinda blodhyfar",
  "block.minecraft.stripped_crimson_stem": "Slinda blodstomn",
  "block.minecraft.stripped_dark_oak_log": "Slinda mørkeikestomn",
  "block.minecraft.stripped_dark_oak_wood": "Slinda mørkeikeved",
  "block.minecraft.stripped_jungle_log": "Slinda jungeltrestomn",
  "block.minecraft.stripped_jungle_wood": "Slinda jungelved",
  "block.minecraft.stripped_mangrove_log": "Slinda mangrovestomn",
  "block.minecraft.stripped_mangrove_wood": "Slinda mangrovetre",
  "block.minecraft.stripped_oak_log": "Slinda eikestomn",
  "block.minecraft.stripped_oak_wood": "Slinda eikeved",
  "block.minecraft.stripped_pale_oak_log": "Slinda bleikeikestomn",
  "block.minecraft.stripped_pale_oak_wood": "Slinda bleikeiketre",
  "block.minecraft.stripped_spruce_log": "Slinda granstomn",
  "block.minecraft.stripped_spruce_wood": "Slinda granved",
  "block.minecraft.stripped_warped_hyphae": "Slinda vridehyfar",
  "block.minecraft.stripped_warped_stem": "Slinda vridestomn",
  "block.minecraft.structure_block": "Bygnadsblokk",
  "block.minecraft.structure_void": "Bygnadstomrom",
  "block.minecraft.sugar_cane": "Sukkerrøyr",
  "block.minecraft.sunflower": "Solvendel",
  "block.minecraft.suspicious_gravel": "Mistenkjeleg grus",
  "block.minecraft.suspicious_sand": "Mistenkjeleg sand",
  "block.minecraft.sweet_berry_bush": "Søtbærbusk",
  "block.minecraft.tall_dry_grass": "Høgt turt gras",
  "block.minecraft.tall_grass": "Høgt gras",
  "block.minecraft.tall_seagrass": "Høgt sjøgras",
  "block.minecraft.target": "Skotskive",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testblokk",
  "block.minecraft.test_instance_block": "Testinstansblokk",
  "block.minecraft.tinted_glass": "Sverta glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-eksplosjonar er avslege",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Kyndelblom",
  "block.minecraft.torchflower_crop": "Kyndelblomavling",
  "block.minecraft.trapped_chest": "Lokkekiste",
  "block.minecraft.trial_spawner": "Røyneframkallar",
  "block.minecraft.tripwire": "Snubletråd",
  "block.minecraft.tripwire_hook": "Snubletrådfeste",
  "block.minecraft.tube_coral": "Orgelkorall",
  "block.minecraft.tube_coral_block": "Orgelkorallblokk",
  "block.minecraft.tube_coral_fan": "Orgelkorallvifte",
  "block.minecraft.tube_coral_wall_fan": "Orgelkorallveggvifte",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Helle av tufftegl",
  "block.minecraft.tuff_brick_stairs": "Trapp av tufftegl",
  "block.minecraft.tuff_brick_wall": "Tuffteglmur",
  "block.minecraft.tuff_bricks": "Tufftegl",
  "block.minecraft.tuff_slab": "Tuffhelle",
  "block.minecraft.tuff_stairs": "Tufftrapp",
  "block.minecraft.tuff_wall": "Tuffmur",
  "block.minecraft.turtle_egg": "Skjelpaddeegg",
  "block.minecraft.twisting_vines": "Krokande klivevokster",
  "block.minecraft.twisting_vines_plant": "Krokande klivevokster",
  "block.minecraft.vault": "Kvelv",
  "block.minecraft.verdant_froglight": "Grønskande froskeljos",
  "block.minecraft.vine": "Klivevokster",
  "block.minecraft.void_air": "Tomromsluft",
  "block.minecraft.wall_torch": "Veggfakkel",
  "block.minecraft.warped_button": "Vrideknapp",
  "block.minecraft.warped_door": "Vridedør",
  "block.minecraft.warped_fence": "Vridegjerde",
  "block.minecraft.warped_fence_gate": "Vridegrind",
  "block.minecraft.warped_fungus": "Vridesopp",
  "block.minecraft.warped_hanging_sign": "Hengande vrideskilt",
  "block.minecraft.warped_hyphae": "Vridehyfar",
  "block.minecraft.warped_nylium": "Vridenycel",
  "block.minecraft.warped_planks": "Vrideplankar",
  "block.minecraft.warped_pressure_plate": "Vridetrykkplate",
  "block.minecraft.warped_roots": "Vriderøter",
  "block.minecraft.warped_shelf": "Vridehylle",
  "block.minecraft.warped_sign": "Vrideskilt",
  "block.minecraft.warped_slab": "Vridehelle",
  "block.minecraft.warped_stairs": "Vridetrapp",
  "block.minecraft.warped_stem": "Vridestomn",
  "block.minecraft.warped_trapdoor": "Vridelem",
  "block.minecraft.warped_wall_hanging_sign": "Hengande vrideskilt på vegg",
  "block.minecraft.warped_wall_sign": "Vrideveggskilt",
  "block.minecraft.warped_wart_block": "Vridevorteblokk",
  "block.minecraft.water": "Vatn",
  "block.minecraft.water_cauldron": "Vassgryte",
  "block.minecraft.waxed_chiseled_copper": "Voksa forma kopar",
  "block.minecraft.waxed_copper_bars": "Voksa kopargitter",
  "block.minecraft.waxed_copper_block": "Voksa koparblokk",
  "block.minecraft.waxed_copper_bulb": "Voksa koparpære",
  "block.minecraft.waxed_copper_chain": "Voksa koparlenkje",
  "block.minecraft.waxed_copper_chest": "Voksa koparkiste",
  "block.minecraft.waxed_copper_door": "Voksa kopardør",
  "block.minecraft.waxed_copper_golem_statue": "Voksa koparkallstytte",
  "block.minecraft.waxed_copper_grate": "Voksa koparrist",
  "block.minecraft.waxed_copper_lantern": "Voksa koparlykt",
  "block.minecraft.waxed_copper_trapdoor": "Voksa koparlem",
  "block.minecraft.waxed_cut_copper": "Voksa skoren kopar",
  "block.minecraft.waxed_cut_copper_slab": "Voksa helle av skoren kopar",
  "block.minecraft.waxed_cut_copper_stairs": "Voksa trapp av skoren kopar",
  "block.minecraft.waxed_exposed_chiseled_copper": "Voksa utsett forma kopar",
  "block.minecraft.waxed_exposed_copper": "Voksa utsett kopar",
  "block.minecraft.waxed_exposed_copper_bars": "Voksa utsett kopargitter",
  "block.minecraft.waxed_exposed_copper_bulb": "Voksa utsett koparpære",
  "block.minecraft.waxed_exposed_copper_chain": "Voksa utsett koparlenkje",
  "block.minecraft.waxed_exposed_copper_chest": "Voksa utsett koparkiste",
  "block.minecraft.waxed_exposed_copper_door": "Voksa utsett kopardør",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Voksa utsett koparkallstytte",
  "block.minecraft.waxed_exposed_copper_grate": "Voksa utsett koparrist",
  "block.minecraft.waxed_exposed_copper_lantern": "Voksa utsett koparlykt",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Voksa utsett koparlem",
  "block.minecraft.waxed_exposed_cut_copper": "Voksa utsett skoren kopar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Voksa utsett helle av skoren kopar",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Voksa utsett trapp av skoren kopar",
  "block.minecraft.waxed_exposed_lightning_rod": "Voksa utsett lynavleiar",
  "block.minecraft.waxed_lightning_rod": "Voksa lynavleiar",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Voksa eira forma kopar",
  "block.minecraft.waxed_oxidized_copper": "Voksa eira kopar",
  "block.minecraft.waxed_oxidized_copper_bars": "Voksa eira kopargitter",
  "block.minecraft.waxed_oxidized_copper_bulb": "Voksa eira koparpære",
  "block.minecraft.waxed_oxidized_copper_chain": "Voksa eira koparlenkje",
  "block.minecraft.waxed_oxidized_copper_chest": "Voksa eira koparkiste",
  "block.minecraft.waxed_oxidized_copper_door": "Voksa eira kopardør",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Voksa eira koparkallstytte",
  "block.minecraft.waxed_oxidized_copper_grate": "Voksa eira koparrist",
  "block.minecraft.waxed_oxidized_copper_lantern": "Voksa eira koparlykt",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Voksa eira koparlem",
  "block.minecraft.waxed_oxidized_cut_copper": "Voksa eira skoren kopar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Voksa eira helle av skoren kopar",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Voksa eira trapp av skoren kopar",
  "block.minecraft.waxed_oxidized_lightning_rod": "Voksa eira lynavleiar",
  "block.minecraft.waxed_weathered_chiseled_copper": "Voksa vêrbiten forma kopar",
  "block.minecraft.waxed_weathered_copper": "Voksa vêrbiten kopar",
  "block.minecraft.waxed_weathered_copper_bars": "Voksa vêrbite kopargitter",
  "block.minecraft.waxed_weathered_copper_bulb": "Voksa vêrbita koparpære",
  "block.minecraft.waxed_weathered_copper_chain": "Voksa vêrbiten koparlenkje",
  "block.minecraft.waxed_weathered_copper_chest": "Voksa vêrbita koparkiste",
  "block.minecraft.waxed_weathered_copper_door": "Voksa vêrbita kopardør",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Voksa vêrbita koparkallstytte",
  "block.minecraft.waxed_weathered_copper_grate": "Voksa vêrbita koparrist",
  "block.minecraft.waxed_weathered_copper_lantern": "Voksa vêrbiten koparlykt",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Voksa vêrbiten koparlem",
  "block.minecraft.waxed_weathered_cut_copper": "Voksa vêrbiten skoren kopar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Voksa vêrbita helle av skoren kopar",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Voksa vêrbita trapp av skoren kopar",
  "block.minecraft.waxed_weathered_lightning_rod": "Voksa vêrbiten lynavleiar",
  "block.minecraft.weathered_chiseled_copper": "Vêrbiten forma kopar",
  "block.minecraft.weathered_copper": "Vêrbiten kopar",
  "block.minecraft.weathered_copper_bars": "Vêrbite kopargitter",
  "block.minecraft.weathered_copper_bulb": "Vêrbita koparpære",
  "block.minecraft.weathered_copper_chain": "Vêrbiten koparlenkje",
  "block.minecraft.weathered_copper_chest": "Vêrbita koparkiste",
  "block.minecraft.weathered_copper_door": "Vêrbita kopardør",
  "block.minecraft.weathered_copper_golem_statue": "Vêrbita koparkallstytte",
  "block.minecraft.weathered_copper_grate": "Vêrbita koparrist",
  "block.minecraft.weathered_copper_lantern": "Vêrbiten koparlykt",
  "block.minecraft.weathered_copper_trapdoor": "Vêrbiten koparlem",
  "block.minecraft.weathered_cut_copper": "Vêrbiten skoren kopar",
  "block.minecraft.weathered_cut_copper_slab": "Vêrbita helle av skoren kopar",
  "block.minecraft.weathered_cut_copper_stairs": "Vêrbita trapp av skoren kopar",
  "block.minecraft.weathered_lightning_rod": "Vêrbiten lynavleiar",
  "block.minecraft.weeping_vines": "Gråtande klivevokster",
  "block.minecraft.weeping_vines_plant": "Gråtande klivevokster",
  "block.minecraft.wet_sponge": "Våt svamp",
  "block.minecraft.wheat": "Kveiteavlingar",
  "block.minecraft.white_banner": "Kvit fane",
  "block.minecraft.white_bed": "Kvit seng",
  "block.minecraft.white_candle": "Kvitt voksljos",
  "block.minecraft.white_candle_cake": "Kake med kvitt voksljos",
  "block.minecraft.white_carpet": "Kvit rye",
  "block.minecraft.white_concrete": "Kvit betong",
  "block.minecraft.white_concrete_powder": "Kvitt betongpulver",
  "block.minecraft.white_glazed_terracotta": "Kvit glasert terrakotta",
  "block.minecraft.white_shulker_box": "Kvit shulkerboks",
  "block.minecraft.white_stained_glass": "Kvitt glas",
  "block.minecraft.white_stained_glass_pane": "Kvit glasrute",
  "block.minecraft.white_terracotta": "Kvit terrakotta",
  "block.minecraft.white_tulip": "Kvit tulipan",
  "block.minecraft.white_wool": "Kvit ull",
  "block.minecraft.wildflowers": "Markblomar",
  "block.minecraft.wither_rose": "Witherrose",
  "block.minecraft.wither_skeleton_skull": "Skalle av witherbeinrangel",
  "block.minecraft.wither_skeleton_wall_skull": "Veggskalle frå witherbeinrangel",
  "block.minecraft.yellow_banner": "Gul fane",
  "block.minecraft.yellow_bed": "Gul seng",
  "block.minecraft.yellow_candle": "Gult voksljos",
  "block.minecraft.yellow_candle_cake": "Kake med gult voksljos",
  "block.minecraft.yellow_carpet": "Gult golvteppe",
  "block.minecraft.yellow_concrete": "Gul betong",
  "block.minecraft.yellow_concrete_powder": "Gult betongpulver",
  "block.minecraft.yellow_glazed_terracotta": "Gul glasert terrakotta",
  "block.minecraft.yellow_shulker_box": "Gul shulkerboks",
  "block.minecraft.yellow_stained_glass": "Gult glas",
  "block.minecraft.yellow_stained_glass_pane": "Gul glasrute",
  "block.minecraft.yellow_terracotta": "Gul terrakotta",
  "block.minecraft.yellow_wool": "Gul ull",
  "block.minecraft.zombie_head": "Daudinghovud",
  "block.minecraft.zombie_wall_head": "Daudingvegghovud",
  "item.minecraft.acacia_boat": "Akasiebåt",
  "item.minecraft.acacia_chest_boat": "Akasiebåt med kiste",
  "item.minecraft.allay_spawn_egg": "Framkalleegg for hjelpeånd",
  "item.minecraft.amethyst_shard": "Ametystbrot",
  "item.minecraft.angler_pottery_shard": "Skålbrot med fiskestong",
  "item.minecraft.angler_pottery_sherd": "Skålbrot med fiskestong",
  "item.minecraft.apple": "Eple",
  "item.minecraft.archer_pottery_shard": "Skålbrot med bogeskyttar",
  "item.minecraft.archer_pottery_sherd": "Skålbrot med bogeskyttar",
  "item.minecraft.armadillo_scute": "Beltedyrskjel",
  "item.minecraft.armadillo_spawn_egg": "Framkalleegg for beltedyr",
  "item.minecraft.armor_stand": "Rustningstativ",
  "item.minecraft.arms_up_pottery_shard": "Skålbrot med armane opp",
  "item.minecraft.arms_up_pottery_sherd": "Skålbrot med armane opp",
  "item.minecraft.arrow": "Pil",
  "item.minecraft.axolotl_bucket": "Bytte med axelotl",
  "item.minecraft.axolotl_spawn_egg": "Framkalleegg for axelotl",
  "item.minecraft.baked_potato": "Bakt potet",
  "item.minecraft.bamboo_chest_raft": "Bambusflòte med kiste",
  "item.minecraft.bamboo_raft": "Bambusflòte",
  "item.minecraft.bat_spawn_egg": "Framkalleegg for skinnvengje",
  "item.minecraft.bee_spawn_egg": "Framkalleegg for bie",
  "item.minecraft.beef": "Rått oksekjøt",
  "item.minecraft.beetroot": "Raudbete",
  "item.minecraft.beetroot_seeds": "Raudbetefrø",
  "item.minecraft.beetroot_soup": "Raudbetesuppe",
  "item.minecraft.birch_boat": "Bjørkebåt",
  "item.minecraft.birch_chest_boat": "Bjørkebåt med kiste",
  "item.minecraft.black_bundle": "Svart sekk",
  "item.minecraft.black_dye": "Svart let",
  "item.minecraft.black_harness": "Svart seletøy",
  "item.minecraft.blade_pottery_shard": "Skålbrot med sverd",
  "item.minecraft.blade_pottery_sherd": "Skålbrot med sverd",
  "item.minecraft.blaze_powder": "Eldpulver",
  "item.minecraft.blaze_rod": "Eldstav",
  "item.minecraft.blaze_spawn_egg": "Framkalleegg for eldskrømt",
  "item.minecraft.blue_bundle": "Blå sekk",
  "item.minecraft.blue_dye": "Blå let",
  "item.minecraft.blue_egg": "Blått egg",
  "item.minecraft.blue_harness": "Blått seletøy",
  "item.minecraft.bogged_spawn_egg": "Framkallingsegg for myrdraug",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smimal",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Lynaktig rustningspryd",
  "item.minecraft.bone": "Bein",
  "item.minecraft.bone_meal": "Beinmjøl",
  "item.minecraft.book": "Bok",
  "item.minecraft.bordure_indented_banner_pattern": "Bord med tannsnitt-bannermønster",
  "item.minecraft.bow": "Boge",
  "item.minecraft.bowl": "Bolle",
  "item.minecraft.bread": "Brød",
  "item.minecraft.breeze_rod": "Vindstav",
  "item.minecraft.breeze_spawn_egg": "Framkalleegg for vindskrømt",
  "item.minecraft.brewer_pottery_shard": "Skålbrot med brygg",
  "item.minecraft.brewer_pottery_sherd": "Skålbrot med brygg",
  "item.minecraft.brewing_stand": "Bryggjereiskap",
  "item.minecraft.brick": "Tegl",
  "item.minecraft.brown_bundle": "Brun sekk",
  "item.minecraft.brown_dye": "Brun let",
  "item.minecraft.brown_egg": "Brunt egg",
  "item.minecraft.brown_harness": "Brunt seletøy",
  "item.minecraft.brush": "Kost",
  "item.minecraft.bucket": "Bytte",
  "item.minecraft.bundle": "Sekk",
  "item.minecraft.bundle.empty": "Tom",
  "item.minecraft.bundle.empty.description": "Kan halda ein blanda hop av gjenstandar",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Skålbrot med eldtunge",
  "item.minecraft.burn_pottery_sherd": "Skålbrot med eldtunge",
  "item.minecraft.camel_husk_spawn_egg": "Framkalleegg for dromedar-skaldauding",
  "item.minecraft.camel_spawn_egg": "Framkalleegg for dromedar",
  "item.minecraft.carrot": "Gulrot",
  "item.minecraft.carrot_on_a_stick": "Gulrot på stong",
  "item.minecraft.cat_spawn_egg": "Framkalleegg for katt",
  "item.minecraft.cauldron": "Gryte",
  "item.minecraft.cave_spider_spawn_egg": "Framkalleegg for hòlevevkjerring",
  "item.minecraft.chainmail_boots": "Brynjestøvlar",
  "item.minecraft.chainmail_chestplate": "Ringbrynje",
  "item.minecraft.chainmail_helmet": "Brynjehette",
  "item.minecraft.chainmail_leggings": "Brynjehose",
  "item.minecraft.charcoal": "Trekol",
  "item.minecraft.cherry_boat": "Kissebærbåt",
  "item.minecraft.cherry_chest_boat": "Kissebærbåt med kiste",
  "item.minecraft.chest_minecart": "Gruvevogn med kiste",
  "item.minecraft.chicken": "Rått hønsekjøt",
  "item.minecraft.chicken_spawn_egg": "Framkalleegg for høne",
  "item.minecraft.chorus_fruit": "Korfrukt",
  "item.minecraft.clay_ball": "Leireball",
  "item.minecraft.clock": "Klokke",
  "item.minecraft.coal": "Kol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Forlist rustningspryd",
  "item.minecraft.cocoa_beans": "Kakaobønner",
  "item.minecraft.cod": "Rå torsk",
  "item.minecraft.cod_bucket": "Torskebytte",
  "item.minecraft.cod_spawn_egg": "Framkalleegg for torsk",
  "item.minecraft.command_block_minecart": "Gruvevogn med kommandoblokk",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Oksesteik",
  "item.minecraft.cooked_chicken": "Steikt høne",
  "item.minecraft.cooked_cod": "Kokt torsk",
  "item.minecraft.cooked_mutton": "Steikt sauekjøt",
  "item.minecraft.cooked_porkchop": "Svinesteik",
  "item.minecraft.cooked_rabbit": "Steikt hare",
  "item.minecraft.cooked_salmon": "Kokt laks",
  "item.minecraft.cookie": "Kjeks",
  "item.minecraft.copper_axe": "Koparøks",
  "item.minecraft.copper_boots": "Koparstøvlar",
  "item.minecraft.copper_chestplate": "Brystplate av kopar",
  "item.minecraft.copper_golem_spawn_egg": "Framkallingsegg for koparkall",
  "item.minecraft.copper_helmet": "Koparhjelm",
  "item.minecraft.copper_hoe": "Kopargrev",
  "item.minecraft.copper_horse_armor": "Koparhesterustning",
  "item.minecraft.copper_ingot": "Koparbarre",
  "item.minecraft.copper_leggings": "Beinplater av kopar",
  "item.minecraft.copper_nautilus_armor": "Koparperlebåtrustning",
  "item.minecraft.copper_nugget": "Koparklump",
  "item.minecraft.copper_pickaxe": "Koparhakke",
  "item.minecraft.copper_shovel": "Koparspade",
  "item.minecraft.copper_spear": "Koparspjut",
  "item.minecraft.copper_sword": "Koparsverd",
  "item.minecraft.cow_spawn_egg": "Framkalleegg for ku",
  "item.minecraft.creaking_spawn_egg": "Framkalleegg for knirkande",
  "item.minecraft.creeper_banner_pattern": "Fanemønster",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-bannermønster",
  "item.minecraft.creeper_spawn_egg": "Framkalleegg for creeper",
  "item.minecraft.crossbow": "Låsboge",
  "item.minecraft.crossbow.projectile": "Skot:",
  "item.minecraft.crossbow.projectile.multiple": "Prosjektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Prosjektil: %s",
  "item.minecraft.cyan_bundle": "Blågrøn sekk",
  "item.minecraft.cyan_dye": "Blågrønlet",
  "item.minecraft.cyan_harness": "Blågrønt seletøy",
  "item.minecraft.danger_pottery_shard": "Skålbrot med creeper",
  "item.minecraft.danger_pottery_sherd": "Skålbrot med creeper",
  "item.minecraft.dark_oak_boat": "Mørkeikebåt",
  "item.minecraft.dark_oak_chest_boat": "Mørkeikebåt med kiste",
  "item.minecraft.debug_stick": "Avlusarpinne",
  "item.minecraft.debug_stick.empty": "%s har ingen eigenskapar",
  "item.minecraft.debug_stick.select": "valde «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» til %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantøks",
  "item.minecraft.diamond_boots": "Diamantstøvlar",
  "item.minecraft.diamond_chestplate": "Brystplate av diamant",
  "item.minecraft.diamond_helmet": "Diamanthjelm",
  "item.minecraft.diamond_hoe": "Diamantgrev",
  "item.minecraft.diamond_horse_armor": "Diamantrustning for hest",
  "item.minecraft.diamond_leggings": "Beinplater av diamant",
  "item.minecraft.diamond_nautilus_armor": "Diamantperlebåtrustning",
  "item.minecraft.diamond_pickaxe": "Diamanthakke",
  "item.minecraft.diamond_shovel": "Diamantspade",
  "item.minecraft.diamond_spear": "Diamantspjut",
  "item.minecraft.diamond_sword": "Diamantsverd",
  "item.minecraft.disc_fragment_5": "Musikkplateskòr",
  "item.minecraft.disc_fragment_5.desc": "Musikkplate – 5",
  "item.minecraft.dolphin_spawn_egg": "Framkalleegg for delfin",
  "item.minecraft.donkey_spawn_egg": "Framkalleegg for asen",
  "item.minecraft.dragon_breath": "Drakeande",
  "item.minecraft.dried_kelp": "Turka tare",
  "item.minecraft.drowned_spawn_egg": "Framkalleegg for draug",
  "item.minecraft.dune_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dynens rustningspryd",
  "item.minecraft.echo_shard": "Atterljomsbrot",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Framkalleegg for eldre verjar",
  "item.minecraft.elytra": "Venger",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Galdrebok",
  "item.minecraft.enchanted_golden_apple": "Trollbunde gulleple",
  "item.minecraft.end_crystal": "Endekrystall",
  "item.minecraft.ender_dragon_spawn_egg": "Framkallingsegg for enderdrake",
  "item.minecraft.ender_eye": "Enderauga",
  "item.minecraft.ender_pearl": "Endeperle",
  "item.minecraft.enderman_spawn_egg": "Framkalleegg for endermann",
  "item.minecraft.endermite_spawn_egg": "Framkalleegg for endermit",
  "item.minecraft.evoker_spawn_egg": "Framkalleegg for åndemanar",
  "item.minecraft.experience_bottle": "Galdreflaske",
  "item.minecraft.explorer_pottery_shard": "Skålbrot med kart",
  "item.minecraft.explorer_pottery_sherd": "Skålbrot med kart",
  "item.minecraft.eye_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Skarpsynt rustningspryd",
  "item.minecraft.feather": "Fjør",
  "item.minecraft.fermented_spider_eye": "Ase vevkjerringauga",
  "item.minecraft.field_masoned_banner_pattern": "Murstein-bannermønster",
  "item.minecraft.filled_map": "Kart",
  "item.minecraft.fire_charge": "Eldkule",
  "item.minecraft.firework_rocket": "Fyrverk",
  "item.minecraft.firework_rocket.flight": "Flygelengd:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fyrverkstjerne",
  "item.minecraft.firework_star.black": "Svart",
  "item.minecraft.firework_star.blue": "Blå",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Tilmåta",
  "item.minecraft.firework_star.cyan": "Blågrøn",
  "item.minecraft.firework_star.fade_to": "Ton inn til",
  "item.minecraft.firework_star.flicker": "Gnistring",
  "item.minecraft.firework_star.gray": "Grå",
  "item.minecraft.firework_star.green": "Grøn",
  "item.minecraft.firework_star.light_blue": "Ljosblå",
  "item.minecraft.firework_star.light_gray": "Ljosgrå",
  "item.minecraft.firework_star.lime": "Limegrøn",
  "item.minecraft.firework_star.magenta": "Ljoslilla",
  "item.minecraft.firework_star.orange": "Oransje",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Lilla",
  "item.minecraft.firework_star.red": "Raud",
  "item.minecraft.firework_star.shape": "Ukjend form",
  "item.minecraft.firework_star.shape.burst": "Utbrot",
  "item.minecraft.firework_star.shape.creeper": "Creeperforma",
  "item.minecraft.firework_star.shape.large_ball": "Stor kule",
  "item.minecraft.firework_star.shape.small_ball": "Lita kule",
  "item.minecraft.firework_star.shape.star": "Stjerne-forma",
  "item.minecraft.firework_star.trail": "Spor",
  "item.minecraft.firework_star.white": "Kvit",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Fiskestong",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Eldjarn",
  "item.minecraft.flow_armor_trim_smithing_template": "Smimal",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Virvlende rustningspryd",
  "item.minecraft.flow_banner_pattern": "Bannermønster",
  "item.minecraft.flow_banner_pattern.desc": "Kvervel",
  "item.minecraft.flow_banner_pattern.new": "Virvel-bannermønster",
  "item.minecraft.flow_pottery_sherd": "Skålbrot med kvervel",
  "item.minecraft.flower_banner_pattern": "Fanemønster",
  "item.minecraft.flower_banner_pattern.desc": "Blome",
  "item.minecraft.flower_banner_pattern.new": "Blomst-bannermønster",
  "item.minecraft.flower_pot": "Blomepotte",
  "item.minecraft.fox_spawn_egg": "Framkalleegg for rev",
  "item.minecraft.friend_pottery_shard": "Skålbrot med venlegt andlet",
  "item.minecraft.friend_pottery_sherd": "Skålbrot med venlegt andlet",
  "item.minecraft.frog_spawn_egg": "Framkallingsegg for frosk",
  "item.minecraft.furnace_minecart": "Gruvevogn med omn",
  "item.minecraft.ghast_spawn_egg": "Framkalleegg for ghast",
  "item.minecraft.ghast_tear": "Ghasttåre",
  "item.minecraft.glass_bottle": "Glasflaske",
  "item.minecraft.glistering_melon_slice": "Glitrande vassmelonbåt",
  "item.minecraft.globe_banner_pattern": "Fanemønster",
  "item.minecraft.globe_banner_pattern.desc": "Klote",
  "item.minecraft.globe_banner_pattern.new": "Globus-bannermønster",
  "item.minecraft.glow_berries": "Glødebær",
  "item.minecraft.glow_ink_sac": "Glødeblekkpose",
  "item.minecraft.glow_item_frame": "Glødande ramme",
  "item.minecraft.glow_squid_spawn_egg": "Framkallingsegg for glødesprut",
  "item.minecraft.glowstone_dust": "Glødestøv",
  "item.minecraft.goat_horn": "Bukkehorn",
  "item.minecraft.goat_spawn_egg": "Framkalleegg for geit",
  "item.minecraft.gold_ingot": "Gullbarre",
  "item.minecraft.gold_nugget": "Gullklump",
  "item.minecraft.golden_apple": "Gulleple",
  "item.minecraft.golden_axe": "Gulløks",
  "item.minecraft.golden_boots": "Gullstøvlar",
  "item.minecraft.golden_carrot": "Gullrot",
  "item.minecraft.golden_chestplate": "Brystplate av gull",
  "item.minecraft.golden_helmet": "Gullhjelm",
  "item.minecraft.golden_hoe": "Gullgrev",
  "item.minecraft.golden_horse_armor": "Gullhesterustning",
  "item.minecraft.golden_leggings": "Beinplater av gull",
  "item.minecraft.golden_nautilus_armor": "Gullperlebåtrustning",
  "item.minecraft.golden_pickaxe": "Gullhakke",
  "item.minecraft.golden_shovel": "Gullspade",
  "item.minecraft.golden_spear": "Gullspjut",
  "item.minecraft.golden_sword": "Gullsverd",
  "item.minecraft.gray_bundle": "Grå sekk",
  "item.minecraft.gray_dye": "Grålet",
  "item.minecraft.gray_harness": "Grått seletøy",
  "item.minecraft.green_bundle": "Grøn sekk",
  "item.minecraft.green_dye": "Grøn let",
  "item.minecraft.green_harness": "Grønt seletøy",
  "item.minecraft.guardian_spawn_egg": "Framkalleegg for verjar",
  "item.minecraft.gunpowder": "Krut",
  "item.minecraft.guster_banner_pattern": "Fanemønster",
  "item.minecraft.guster_banner_pattern.desc": "Vindskrømt",
  "item.minecraft.guster_banner_pattern.new": "Vindkaster-bannermønster",
  "item.minecraft.guster_pottery_sherd": "Skålbrot med vindskrømt",
  "item.minecraft.happy_ghast_spawn_egg": "Framkalleegg for gladghast",
  "item.minecraft.harness": "Seletøy",
  "item.minecraft.heart_of_the_sea": "Havhjarta",
  "item.minecraft.heart_pottery_shard": "Skålbrot med hjarta",
  "item.minecraft.heart_pottery_sherd": "Skålbrot med hjarta",
  "item.minecraft.heartbreak_pottery_shard": "Skålbrot med brote hjarta",
  "item.minecraft.heartbreak_pottery_sherd": "Skålbrot med brote hjarta",
  "item.minecraft.hoglin_spawn_egg": "Framkalleegg for hoglin",
  "item.minecraft.honey_bottle": "Honningflaske",
  "item.minecraft.honeycomb": "Vokskake",
  "item.minecraft.hopper_minecart": "Gruvevogn med trekt",
  "item.minecraft.horse_spawn_egg": "Framkalleegg for hest",
  "item.minecraft.host_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.host_armor_trim_smithing_template.new": "Vertens rustningspryd",
  "item.minecraft.howl_pottery_shard": "Skålbrot med varg",
  "item.minecraft.howl_pottery_sherd": "Skålbrot med varg",
  "item.minecraft.husk_spawn_egg": "Framkalleegg for skaldauding",
  "item.minecraft.ink_sac": "Blekkpose",
  "item.minecraft.iron_axe": "Jarnøks",
  "item.minecraft.iron_boots": "Jarnstøvlar",
  "item.minecraft.iron_chestplate": "Brystplate av jarn",
  "item.minecraft.iron_golem_spawn_egg": "Framkallingsegg for jarnkjempe",
  "item.minecraft.iron_helmet": "Jarnhjelm",
  "item.minecraft.iron_hoe": "Jarngrev",
  "item.minecraft.iron_horse_armor": "Jarnrustning for hest",
  "item.minecraft.iron_ingot": "Jarnbarre",
  "item.minecraft.iron_leggings": "Beinplater av jarn",
  "item.minecraft.iron_nautilus_armor": "Jarnperlebåtrustning",
  "item.minecraft.iron_nugget": "Jarnklump",
  "item.minecraft.iron_pickaxe": "Jarnhakke",
  "item.minecraft.iron_shovel": "Jarnspade",
  "item.minecraft.iron_spear": "Jarnspjut",
  "item.minecraft.iron_sword": "Jarnsverd",
  "item.minecraft.item_frame": "Ramme",
  "item.minecraft.jungle_boat": "Jungeltrebåt",
  "item.minecraft.jungle_chest_boat": "Jungelbåt med kiste",
  "item.minecraft.knowledge_book": "Kunnebok",
  "item.minecraft.lapis_lazuli": "Lasurstein",
  "item.minecraft.lava_bucket": "Lavabytte",
  "item.minecraft.lead": "Band",
  "item.minecraft.leather": "Lêr",
  "item.minecraft.leather_boots": "Skinnstøvlar",
  "item.minecraft.leather_chestplate": "Skinntrøye",
  "item.minecraft.leather_helmet": "Skinnhuve",
  "item.minecraft.leather_horse_armor": "Lêrhesterustning",
  "item.minecraft.leather_leggings": "Skinnbrok",
  "item.minecraft.light_blue_bundle": "Ljosblå sekk",
  "item.minecraft.light_blue_dye": "Ljosblålet",
  "item.minecraft.light_blue_harness": "Ljosblått seletøy",
  "item.minecraft.light_gray_bundle": "Ljosgrå sekk",
  "item.minecraft.light_gray_dye": "Ljosgrålet",
  "item.minecraft.light_gray_harness": "Ljosgrått seletøy",
  "item.minecraft.lime_bundle": "Limegrøn sekk",
  "item.minecraft.lime_dye": "Limegrønlet",
  "item.minecraft.lime_harness": "Limegrønt seletøy",
  "item.minecraft.lingering_potion": "Dvelande trolldrykk",
  "item.minecraft.lingering_potion.effect.awkward": "Dvelande uhendugt brygg",
  "item.minecraft.lingering_potion.effect.empty": "Dvelande ulageleg brygg",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dvelande eldvernsbrygg",
  "item.minecraft.lingering_potion.effect.harming": "Dvelande skadebrygg",
  "item.minecraft.lingering_potion.effect.healing": "Dvelande lækjebrygg",
  "item.minecraft.lingering_potion.effect.infested": "Dvelande fengjebrygg",
  "item.minecraft.lingering_potion.effect.invisibility": "Dvelande usynleiksbrygg",
  "item.minecraft.lingering_potion.effect.leaping": "Dvelande byksebrygg",
  "item.minecraft.lingering_potion.effect.levitation": "Dvelande svivebrygg",
  "item.minecraft.lingering_potion.effect.luck": "Dvelande lukkebrygg",
  "item.minecraft.lingering_potion.effect.mundane": "Dvelande måteleg brygg",
  "item.minecraft.lingering_potion.effect.night_vision": "Dvelande nattsynsbrygg",
  "item.minecraft.lingering_potion.effect.oozing": "Dvelande tytebrygg",
  "item.minecraft.lingering_potion.effect.poison": "Dvelande giftig brygg",
  "item.minecraft.lingering_potion.effect.regeneration": "Dvelande attskapingsbrygg",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dvelande seinfallsbrygg",
  "item.minecraft.lingering_potion.effect.slowness": "Dvelande tråleiksbrygg",
  "item.minecraft.lingering_potion.effect.strength": "Dvelande styrkebrygg",
  "item.minecraft.lingering_potion.effect.swiftness": "Dvelande snøggleiksbrygg",
  "item.minecraft.lingering_potion.effect.thick": "Dvelande tjuktflytande brygg",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dvelande brygg frå skjelpaddemeisteren",
  "item.minecraft.lingering_potion.effect.water": "Dvelande vassflaske",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dvelande vassandingsbrygg",
  "item.minecraft.lingering_potion.effect.weakness": "Dvelande veikjebrygg",
  "item.minecraft.lingering_potion.effect.weaving": "Dvelande verebrygg",
  "item.minecraft.lingering_potion.effect.wind_charged": "Dvelande vindladingsbrygg",
  "item.minecraft.llama_spawn_egg": "Framkalleegg for lama",
  "item.minecraft.lodestone_compass": "Kompass for leidarstein",
  "item.minecraft.mace": "Stridsklubbe",
  "item.minecraft.magenta_bundle": "Ljoslilla sekk",
  "item.minecraft.magenta_dye": "Ljoslillalet",
  "item.minecraft.magenta_harness": "Ljoslilla seletøy",
  "item.minecraft.magma_cream": "Magmakrem",
  "item.minecraft.magma_cube_spawn_egg": "Framkalleegg for magmakube",
  "item.minecraft.mangrove_boat": "Mangrovebåt",
  "item.minecraft.mangrove_chest_boat": "Mangrovemåt med kiste",
  "item.minecraft.map": "Tomt kart",
  "item.minecraft.melon_seeds": "Melonfrø",
  "item.minecraft.melon_slice": "Melonbåt",
  "item.minecraft.milk_bucket": "Mjølkebytte",
  "item.minecraft.minecart": "Gruvevogn",
  "item.minecraft.miner_pottery_shard": "Skålbrot med hakke",
  "item.minecraft.miner_pottery_sherd": "Skålbrot med hakke",
  "item.minecraft.mojang_banner_pattern": "Fanemønster",
  "item.minecraft.mojang_banner_pattern.desc": "Ting",
  "item.minecraft.mojang_banner_pattern.new": "Dings-bannermønster",
  "item.minecraft.mooshroom_spawn_egg": "Framkalleegg for mooshroom",
  "item.minecraft.mourner_pottery_shard": "Skålbrot med syrgjande",
  "item.minecraft.mourner_pottery_sherd": "Skålbrot med vord",
  "item.minecraft.mule_spawn_egg": "Framkalleegg for muldyr",
  "item.minecraft.mushroom_stew": "Soppgryte",
  "item.minecraft.music_disc_11": "Musikkplate",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musikkplate",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musikkplate",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg – 5",
  "item.minecraft.music_disc_blocks": "Musikkplate",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musikkplate",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musikkplate",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musikkplate",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Musikkplate",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Speledåse)",
  "item.minecraft.music_disc_far": "Musikkplate",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musikkplate",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Musikkplate",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musikkplate",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musikkplate",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Musikkplate",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musikkplate",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Musikkplate",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Musikkplate",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musikkplate",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musikkplate",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musikkplate",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musikkplate",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rått sauekjøt",
  "item.minecraft.name_tag": "Namneskilt",
  "item.minecraft.nautilus_shell": "Perlebåthus",
  "item.minecraft.nautilus_spawn_egg": "Framkalleegg for perlebåt",
  "item.minecraft.nether_brick": "Nethertegl",
  "item.minecraft.nether_star": "Netherstjerne",
  "item.minecraft.nether_wart": "Nethervorte",
  "item.minecraft.netherite_axe": "Netherittøks",
  "item.minecraft.netherite_boots": "Netherittstøvlar",
  "item.minecraft.netherite_chestplate": "Brystplate av netheritt",
  "item.minecraft.netherite_helmet": "Netheritthjelm",
  "item.minecraft.netherite_hoe": "Netherittljå",
  "item.minecraft.netherite_horse_armor": "Netheritthesterustning",
  "item.minecraft.netherite_ingot": "Netherittbarre",
  "item.minecraft.netherite_leggings": "Beinplater av netheritt",
  "item.minecraft.netherite_nautilus_armor": "Netherittperlebåtrustning",
  "item.minecraft.netherite_pickaxe": "Netheritthakke",
  "item.minecraft.netherite_scrap": "Netherittskrap",
  "item.minecraft.netherite_shovel": "Netherittspade",
  "item.minecraft.netherite_spear": "Netherittspjut",
  "item.minecraft.netherite_sword": "Netherittsverd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smideskant",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherittoppgradering",
  "item.minecraft.oak_boat": "Eikebåt",
  "item.minecraft.oak_chest_boat": "Eikebåt med kiste",
  "item.minecraft.ocelot_spawn_egg": "Framkalleegg for ozelot",
  "item.minecraft.ominous_bottle": "Illevarslende flaske",
  "item.minecraft.ominous_trial_key": "Illevarande røynelykel",
  "item.minecraft.orange_bundle": "Oransje sekk",
  "item.minecraft.orange_dye": "Oransjelet",
  "item.minecraft.orange_harness": "Oransje seletøy",
  "item.minecraft.painting": "Målarstykke",
  "item.minecraft.pale_oak_boat": "Bleikeikebåt",
  "item.minecraft.pale_oak_chest_boat": "Bleikeikebåt med kiste",
  "item.minecraft.panda_spawn_egg": "Framkalleegg for pandabjørn",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Fremkallingsegg for knusktørket",
  "item.minecraft.parrot_spawn_egg": "Framkalleegg for papegøye",
  "item.minecraft.phantom_membrane": "Fantomhinne",
  "item.minecraft.phantom_spawn_egg": "Framkalleegg for fantom",
  "item.minecraft.pig_spawn_egg": "Framkalleegg for gris",
  "item.minecraft.piglin_banner_pattern": "Fanemønster",
  "item.minecraft.piglin_banner_pattern.desc": "Snut",
  "item.minecraft.piglin_banner_pattern.new": "Snute-bannermønster",
  "item.minecraft.piglin_brute_spawn_egg": "Framkalleegg for piglinråskinn",
  "item.minecraft.piglin_spawn_egg": "Framkalleegg for piglin",
  "item.minecraft.pillager_spawn_egg": "Framkalleegg for plyndrar",
  "item.minecraft.pink_bundle": "Rosa sekk",
  "item.minecraft.pink_dye": "Rosalet",
  "item.minecraft.pink_harness": "Rosa seletøy",
  "item.minecraft.pitcher_plant": "Kanneberar",
  "item.minecraft.pitcher_pod": "Krukkefrø",
  "item.minecraft.plenty_pottery_shard": "Skålbrot med kiste",
  "item.minecraft.plenty_pottery_sherd": "Skålbrot med kiste",
  "item.minecraft.poisonous_potato": "Giftig potet",
  "item.minecraft.polar_bear_spawn_egg": "Framkalleegg for kvitebjørn",
  "item.minecraft.popped_chorus_fruit": "Sprungen korfrukt",
  "item.minecraft.porkchop": "Rått svinekjøt",
  "item.minecraft.potato": "Potet",
  "item.minecraft.potion": "Trolldrykk",
  "item.minecraft.potion.effect.awkward": "Uhendugt brygg",
  "item.minecraft.potion.effect.empty": "Ulageleg brygg",
  "item.minecraft.potion.effect.fire_resistance": "Eldvernsbrygg",
  "item.minecraft.potion.effect.harming": "Skadebrygg",
  "item.minecraft.potion.effect.healing": "Lækjebrygg",
  "item.minecraft.potion.effect.infested": "Fengjebrygg",
  "item.minecraft.potion.effect.invisibility": "Usynleiksbrygg",
  "item.minecraft.potion.effect.leaping": "Byksebrygg",
  "item.minecraft.potion.effect.levitation": "Svivebrygg",
  "item.minecraft.potion.effect.luck": "Lukkebrygg",
  "item.minecraft.potion.effect.mundane": "Måteleg brygg",
  "item.minecraft.potion.effect.night_vision": "Nattsynsbrygg",
  "item.minecraft.potion.effect.oozing": "Tytebrygg",
  "item.minecraft.potion.effect.poison": "Giftig brygg",
  "item.minecraft.potion.effect.regeneration": "Attskapingsbrygg",
  "item.minecraft.potion.effect.slow_falling": "Fjørfallingsbrygg",
  "item.minecraft.potion.effect.slowness": "Tråleiksbrygg",
  "item.minecraft.potion.effect.strength": "Styrkjebrygg",
  "item.minecraft.potion.effect.swiftness": "Snøggleiksbrygg",
  "item.minecraft.potion.effect.thick": "Tjuktflytande brygg",
  "item.minecraft.potion.effect.turtle_master": "Brygg frå skjelpaddemeisteren",
  "item.minecraft.potion.effect.water": "Vassflaske",
  "item.minecraft.potion.effect.water_breathing": "Vassandingsbrygg",
  "item.minecraft.potion.effect.weakness": "Veikjebrygg",
  "item.minecraft.potion.effect.weaving": "Vevebrygg",
  "item.minecraft.potion.effect.wind_charged": "Vindladingsbrygg",
  "item.minecraft.pottery_shard_archer": "Skålbrot med bogeskyttar",
  "item.minecraft.pottery_shard_arms_up": "Skålbrot med armane opp",
  "item.minecraft.pottery_shard_prize": "Skålbrot med glimestein",
  "item.minecraft.pottery_shard_skull": "Skålbrot med skalle",
  "item.minecraft.powder_snow_bucket": "Bytte med nysnø",
  "item.minecraft.prismarine_crystals": "Prismarinkrystallar",
  "item.minecraft.prismarine_shard": "Prismarinbrot",
  "item.minecraft.prize_pottery_shard": "Skålbrot med glimestein",
  "item.minecraft.prize_pottery_sherd": "Skålbrot med glimestein",
  "item.minecraft.pufferfish": "Kulefisk",
  "item.minecraft.pufferfish_bucket": "Kulefiskebytte",
  "item.minecraft.pufferfish_spawn_egg": "Framkalleegg for kulefisk",
  "item.minecraft.pumpkin_pie": "Graskarpai",
  "item.minecraft.pumpkin_seeds": "Graskarfrø",
  "item.minecraft.purple_bundle": "Lilla sekk",
  "item.minecraft.purple_dye": "Lillalet",
  "item.minecraft.purple_harness": "Lilla seletøy",
  "item.minecraft.quartz": "Nether-kvarts",
  "item.minecraft.rabbit": "Rått harekjøt",
  "item.minecraft.rabbit_foot": "Harelabb",
  "item.minecraft.rabbit_hide": "Harefell",
  "item.minecraft.rabbit_spawn_egg": "Framkalleegg for hare",
  "item.minecraft.rabbit_stew": "Haregryte",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Oppdretterens rustningspryd",
  "item.minecraft.ravager_spawn_egg": "Framkalleegg for herjar",
  "item.minecraft.raw_copper": "Råkopar",
  "item.minecraft.raw_gold": "Rågull",
  "item.minecraft.raw_iron": "Råjarn",
  "item.minecraft.recovery_compass": "Attskapingskompass",
  "item.minecraft.red_bundle": "Raud sekk",
  "item.minecraft.red_dye": "Raud let",
  "item.minecraft.red_harness": "Raudt seletøy",
  "item.minecraft.redstone": "Redstone-pulver",
  "item.minecraft.resin_brick": "Kvaetegl",
  "item.minecraft.resin_clump": "Kvaeklump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ribbeinsaktig rustningspryd",
  "item.minecraft.rotten_flesh": "Ròte kjøt",
  "item.minecraft.saddle": "Sâl",
  "item.minecraft.salmon": "Rå laks",
  "item.minecraft.salmon_bucket": "Laksebytte",
  "item.minecraft.salmon_spawn_egg": "Framkalleegg for laks",
  "item.minecraft.scrape_pottery_sherd": "Skålbrot med øks",
  "item.minecraft.scute": "Skjel",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Plyndret rustningspryd",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formgiverens rustningspryd",
  "item.minecraft.sheaf_pottery_shard": "Skålbrot med avling",
  "item.minecraft.sheaf_pottery_sherd": "Skålbrot med avling",
  "item.minecraft.shears": "Saks",
  "item.minecraft.sheep_spawn_egg": "Framkalleegg for sau",
  "item.minecraft.shelter_pottery_shard": "Skålbrot med tre",
  "item.minecraft.shelter_pottery_sherd": "Skålbrot med tre",
  "item.minecraft.shield": "Skjold",
  "item.minecraft.shield.black": "Svart skjold",
  "item.minecraft.shield.blue": "Blått skjold",
  "item.minecraft.shield.brown": "Brunt skjold",
  "item.minecraft.shield.cyan": "Blågrønt skjold",
  "item.minecraft.shield.gray": "Grått skjold",
  "item.minecraft.shield.green": "Grønt skjold",
  "item.minecraft.shield.light_blue": "Ljosblått skjold",
  "item.minecraft.shield.light_gray": "Ljosgrått skjold",
  "item.minecraft.shield.lime": "Limegrønt skjold",
  "item.minecraft.shield.magenta": "Ljoslilla skjold",
  "item.minecraft.shield.orange": "Oransje skjold",
  "item.minecraft.shield.pink": "Rosa skjold",
  "item.minecraft.shield.purple": "Lilla skjold",
  "item.minecraft.shield.red": "Raudt skjold",
  "item.minecraft.shield.white": "Kvitt skjold",
  "item.minecraft.shield.yellow": "Gult skjold",
  "item.minecraft.shulker_shell": "Shulkerskal",
  "item.minecraft.shulker_spawn_egg": "Framkalleegg for shulker",
  "item.minecraft.sign": "Skilt",
  "item.minecraft.silence_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stillhetens rustningspryd",
  "item.minecraft.silverfish_spawn_egg": "Framkalleegg for sylvkrek",
  "item.minecraft.skeleton_horse_spawn_egg": "Framkalleegg for hestebeinrangel",
  "item.minecraft.skeleton_spawn_egg": "Framkalleegg for beinrangel",
  "item.minecraft.skull_banner_pattern": "Fanemønster",
  "item.minecraft.skull_banner_pattern.desc": "Skalle",
  "item.minecraft.skull_banner_pattern.new": "Hodeskalle-bannermønster",
  "item.minecraft.skull_pottery_shard": "Skålbrot med skalle",
  "item.minecraft.skull_pottery_sherd": "Skålbrot med skalle",
  "item.minecraft.slime_ball": "Slimball",
  "item.minecraft.slime_spawn_egg": "Framkalleegg for sliming",
  "item.minecraft.smithing_template": "Smideskant",
  "item.minecraft.smithing_template.applies_to": "Vert bruka på:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Legg til barre eller krystall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rustning",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Legg til stykke av rustning",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barrar og krystallar",
  "item.minecraft.smithing_template.ingredients": "Innehald:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Legg til netherittbarre",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantutstyr",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Legg til rustning, våpen eller reidskap av diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherittbarre",
  "item.minecraft.smithing_template.upgrade": "Betring: ",
  "item.minecraft.sniffer_spawn_egg": "Framkalleegg for moldnase",
  "item.minecraft.snort_pottery_shard": "Skålbrot med moldnase",
  "item.minecraft.snort_pottery_sherd": "Skålbrot med moldnase",
  "item.minecraft.snout_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snuteaktig rustningspryd",
  "item.minecraft.snow_golem_spawn_egg": "Framkallingsegg for snømann",
  "item.minecraft.snowball": "Snøball",
  "item.minecraft.spectral_arrow": "Merkingspil",
  "item.minecraft.spider_eye": "Vevkjerringauga",
  "item.minecraft.spider_spawn_egg": "Framkalleegg for vevkjerring",
  "item.minecraft.spire_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spirens rustningspryd",
  "item.minecraft.splash_potion": "Kastebrygg",
  "item.minecraft.splash_potion.effect.awkward": "Uhendugt kastebrygg",
  "item.minecraft.splash_potion.effect.empty": "Ulageleg kastebrygg",
  "item.minecraft.splash_potion.effect.fire_resistance": "Kasteleg eldvernsbrygg",
  "item.minecraft.splash_potion.effect.harming": "Kasteleg skadebrygg",
  "item.minecraft.splash_potion.effect.healing": "Kasteleg lækjebrygg",
  "item.minecraft.splash_potion.effect.infested": "Kasteleg fengjebrygg",
  "item.minecraft.splash_potion.effect.invisibility": "Kasteleg usynleiksbrygg",
  "item.minecraft.splash_potion.effect.leaping": "Kasteleg byksebrygg",
  "item.minecraft.splash_potion.effect.levitation": "Kasteleg svivebrygg",
  "item.minecraft.splash_potion.effect.luck": "Kasteleg lukkebrygg",
  "item.minecraft.splash_potion.effect.mundane": "Måteleg kastebrygg",
  "item.minecraft.splash_potion.effect.night_vision": "Kasteleg nattsynsbrygg",
  "item.minecraft.splash_potion.effect.oozing": "Kasteleg tytebrygg",
  "item.minecraft.splash_potion.effect.poison": "Giftig kastebrygg",
  "item.minecraft.splash_potion.effect.regeneration": "Kasteleg attskapingsbrygg",
  "item.minecraft.splash_potion.effect.slow_falling": "Kasteleg fjørfallingsbrygg",
  "item.minecraft.splash_potion.effect.slowness": "Kasteleg tråleiksbrygg",
  "item.minecraft.splash_potion.effect.strength": "Kasteleg styrkjebrygg",
  "item.minecraft.splash_potion.effect.swiftness": "Kasteleg snøggleiksbrygg",
  "item.minecraft.splash_potion.effect.thick": "Tjukt kastebrygg",
  "item.minecraft.splash_potion.effect.turtle_master": "Kastebrygg frå skjelpaddemeisteren",
  "item.minecraft.splash_potion.effect.water": "Kastbar vassflaske",
  "item.minecraft.splash_potion.effect.water_breathing": "Kasteleg vassandingsbrygg",
  "item.minecraft.splash_potion.effect.weakness": "Kasteleg veikjebrygg",
  "item.minecraft.splash_potion.effect.weaving": "Kasteleg vevebrygg",
  "item.minecraft.splash_potion.effect.wind_charged": "Kasteleg vindladingsbrygg",
  "item.minecraft.spruce_boat": "Granbåt",
  "item.minecraft.spruce_chest_boat": "Granbåt med kiste",
  "item.minecraft.spyglass": "Kikert",
  "item.minecraft.squid_spawn_egg": "Framkalleegg for blekksprut",
  "item.minecraft.stick": "Pinne",
  "item.minecraft.stone_axe": "Steinøks",
  "item.minecraft.stone_hoe": "Steingrev",
  "item.minecraft.stone_pickaxe": "Steinhakke",
  "item.minecraft.stone_shovel": "Steinspade",
  "item.minecraft.stone_spear": "Steinspjut",
  "item.minecraft.stone_sword": "Steinsverd",
  "item.minecraft.stray_spawn_egg": "Framkalleegg for vandrar",
  "item.minecraft.strider_spawn_egg": "Framkalleegg for stegar",
  "item.minecraft.string": "Tråd",
  "item.minecraft.sugar": "Sukker",
  "item.minecraft.suspicious_stew": "Tvilsam gryterett",
  "item.minecraft.sweet_berries": "Søtbær",
  "item.minecraft.tadpole_bucket": "Bytte med rumpetroll",
  "item.minecraft.tadpole_spawn_egg": "Framkallingsegg for rumpetroll",
  "item.minecraft.tide_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Fjærens rustningspryd",
  "item.minecraft.tipped_arrow": "Dyppa pil",
  "item.minecraft.tipped_arrow.effect.awkward": "Duva pil",
  "item.minecraft.tipped_arrow.effect.empty": "Ulageleg duppa pil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Eldvernspil",
  "item.minecraft.tipped_arrow.effect.harming": "Skadepil",
  "item.minecraft.tipped_arrow.effect.healing": "Lækjepil",
  "item.minecraft.tipped_arrow.effect.infested": "Fengjepil",
  "item.minecraft.tipped_arrow.effect.invisibility": "Usynleikspil",
  "item.minecraft.tipped_arrow.effect.leaping": "Byksepil",
  "item.minecraft.tipped_arrow.effect.levitation": "Svivepil",
  "item.minecraft.tipped_arrow.effect.luck": "Lukkepil",
  "item.minecraft.tipped_arrow.effect.mundane": "Duva pil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Nattsynspil",
  "item.minecraft.tipped_arrow.effect.oozing": "Tytepil",
  "item.minecraft.tipped_arrow.effect.poison": "Giftpil",
  "item.minecraft.tipped_arrow.effect.regeneration": "Attskapingspil",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Fjørfallingspil",
  "item.minecraft.tipped_arrow.effect.slowness": "Tråleikspil",
  "item.minecraft.tipped_arrow.effect.strength": "Styrkjepil",
  "item.minecraft.tipped_arrow.effect.swiftness": "Snøggleikspil",
  "item.minecraft.tipped_arrow.effect.thick": "Duva pil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pil frå skjelpaddemeisteren",
  "item.minecraft.tipped_arrow.effect.water": "Pil med kastbar-verknad",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vassandingspil",
  "item.minecraft.tipped_arrow.effect.weakness": "Veikjepil",
  "item.minecraft.tipped_arrow.effect.weaving": "Vevepil",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vindladingspil",
  "item.minecraft.tnt_minecart": "Gruvevogn med TNT",
  "item.minecraft.torchflower_seeds": "Frø av kyndelblom",
  "item.minecraft.totem_of_undying": "Totem mot døying",
  "item.minecraft.trader_llama_spawn_egg": "Framkalleegg for kjøpmannslama",
  "item.minecraft.trial_key": "Røynelykel",
  "item.minecraft.trident": "Ljoster",
  "item.minecraft.tropical_fish": "Sudhavsfisk",
  "item.minecraft.tropical_fish_bucket": "Sudhavsfiskebytte",
  "item.minecraft.tropical_fish_spawn_egg": "Framkalleegg for sudhavsfisk",
  "item.minecraft.turtle_helmet": "Skjelpaddeskal",
  "item.minecraft.turtle_scute": "Skjelpaddeskjel",
  "item.minecraft.turtle_spawn_egg": "Framkalleegg for skjelpadde",
  "item.minecraft.vex_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plageåndens rustningspryd",
  "item.minecraft.vex_spawn_egg": "Framkalleegg for plageånd",
  "item.minecraft.villager_spawn_egg": "Framkalleegg for bygdebu",
  "item.minecraft.vindicator_spawn_egg": "Framkalleegg for forsvarar",
  "item.minecraft.wandering_trader_spawn_egg": "Framkalleegg for farande kjøpmann",
  "item.minecraft.ward_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Forvart rustningspryd",
  "item.minecraft.warden_spawn_egg": "Framkalleegg for vord",
  "item.minecraft.warped_fungus_on_a_stick": "Vriden sopp på stong",
  "item.minecraft.water_bucket": "Vassbytte",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Veiviserens rustningspryd",
  "item.minecraft.wheat": "Kveite",
  "item.minecraft.wheat_seeds": "Kveitefrø",
  "item.minecraft.white_bundle": "Kvit sekk",
  "item.minecraft.white_dye": "Kvit let",
  "item.minecraft.white_harness": "Kvitt seletøy",
  "item.minecraft.wild_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vill rustningspryd",
  "item.minecraft.wind_charge": "Vindkule",
  "item.minecraft.witch_spawn_egg": "Framkalleegg for trollkjerring",
  "item.minecraft.wither_skeleton_spawn_egg": "Framkalleegg for witherbeinrangel",
  "item.minecraft.wither_spawn_egg": "Framkallingsegg for wither",
  "item.minecraft.wolf_armor": "Vargrustning",
  "item.minecraft.wolf_spawn_egg": "Framkalleegg for varg",
  "item.minecraft.wooden_axe": "Treøks",
  "item.minecraft.wooden_hoe": "Tregrev",
  "item.minecraft.wooden_pickaxe": "Trehakke",
  "item.minecraft.wooden_shovel": "Trespade",
  "item.minecraft.wooden_spear": "Trespjut",
  "item.minecraft.wooden_sword": "Tresverd",
  "item.minecraft.writable_book": "Bok og fjørpenn",
  "item.minecraft.written_book": "Skriva bok",
  "item.minecraft.yellow_bundle": "Gul sekk",
  "item.minecraft.yellow_dye": "Gul let",
  "item.minecraft.yellow_harness": "Gult seletøy",
  "item.minecraft.zoglin_spawn_egg": "Framkalleegg for zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Framkalleegg for hestedauding",
  "item.minecraft.zombie_nautilus_spawn_egg": "Framkalleegg for perlebåtdauding",
  "item.minecraft.zombie_spawn_egg": "Framkalleegg for dauding",
  "item.minecraft.zombie_villager_spawn_egg": "Framkalleegg for bygdedauding",
  "item.minecraft.zombified_piglin_spawn_egg": "Framkalleegg for piglindauding"
}
export const nn_no = items; 
